var _style, _rect, _rect2, _rect3, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision2030(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 366.89",
    style: {
      enableBackground: "new 0 0 595.28 366.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#1E1E21;}\r\n\t.st2{fill:#000000;}\r\n\t.st3{fill:#28316F;}\r\n\t.st4{fill:#000000;}\r\n\t.st5{fill:#D5D505;}\r\n\t.st6{fill:#75B12F;}\r\n\t.st7{fill:#29B0BA;}\r\n\t.st8{fill:#5AAC4C;}\r\n\t.st9{fill:#2983C6;}\r\n\t.st10{fill:#213466;}\r\n\t.st11{fill:#757A81;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 595.28,
    height: 366.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -647,
    className: "st1",
    width: 595.28,
    height: 366.89
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1290,
    className: "st0",
    width: 595.28,
    height: 366.89
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -952.47,
    y: 58.23,
    className: "st1",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: -865.38,
    y: 110.2,
    className: "st1",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-814.47,105.72c1.03-0.49,1.86-1.19,2.49-2.12c0.63-0.92,1.07-2.04,1.33-3.34c0.26-1.31,0.39-2.78,0.39-4.41    V66.59h-4.19v29.26c0,1.18-0.06,2.18-0.18,3s-0.33,1.48-0.63,1.99c-0.3,0.5-0.7,0.87-1.2,1.1c-0.51,0.23-1.16,0.34-1.96,0.34    c-0.38,0-0.72-0.02-0.99-0.05c-0.28-0.03-0.66-0.12-1.15-0.26l-1.1,4.02c1.15,0.32,2.29,0.47,3.4,0.47    C-816.77,106.45-815.5,106.21-814.47,105.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-828.87,59.18h-5.75v-0.97c0-0.53,0.11-0.94,0.34-1.23c0.19-0.24,0.64-0.36,1.29-0.36h2.88v-2.91h-2.95    c-1.6,0-2.85,0.42-3.69,1.25c-0.85,0.83-1.28,2.19-1.28,4.02v3.41h9.17L-828.87,59.18L-828.87,59.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -873.76,
    y: 110.2,
    className: "st1",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: -944.09,
    y: 58.23,
    className: "st1",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-847.74,91.64c1.59,1.13,3.43,1.97,5.52,2.51s4.31,0.81,6.65,0.81h1.11l1.41-2.95v4.15    c0,2.19-0.63,3.76-1.88,4.7c-1.26,0.94-3.02,1.41-5.29,1.41c-1.29,0-2.45-0.12-3.48-0.37c-1.03-0.24-2.21-0.66-3.53-1.25    l-1.31,4.02c1.6,0.59,3.03,1.04,4.27,1.33c1.24,0.3,2.49,0.44,3.74,0.44c4.08,0,7.05-0.97,8.9-2.9c1.85-1.94,2.77-4.54,2.77-7.81    V66.59h-6.7c-2.58,0-4.94,0.37-7.07,1.1c-2.13,0.73-3.95,1.73-5.47,3c-1.52,1.27-2.7,2.79-3.53,4.55    c-0.84,1.76-1.26,3.67-1.26,5.72c0,2.47,0.46,4.59,1.39,6.35C-850.59,89.06-849.33,90.51-847.74,91.64z M-847.74,76.83    c0.64-1.25,1.5-2.32,2.56-3.21s2.28-1.57,3.64-2.06c1.32-0.47,2.69-0.71,4.11-0.72v-0.01h6.77l-2.39,1.19v18.77h-4.24    c-1.57,0-3.04-0.22-4.42-0.66c-1.38-0.43-2.59-1.07-3.64-1.91c-1.05-0.84-1.87-1.86-2.46-3.08s-0.89-2.61-0.89-4.18    C-848.71,79.46-848.39,78.08-847.74,76.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-951.33,105.87h8.7v-3.13c0.08,0.15,0.17,0.3,0.26,0.43c0.63,0.92,1.46,1.63,2.49,2.12    c1.03,0.49,2.29,0.73,3.79,0.73h76.35V66.59h-4.19v35.26h-4.35h-67.66c-0.8,0-1.46-0.11-1.96-0.34c-0.5-0.23-0.91-0.59-1.2-1.1    c-0.29-0.51-0.5-1.17-0.63-1.99c-0.12-0.82-0.18-1.82-0.18-3V66.59h-11.32c-11.58,0-19.46,9.17-19.46,19.64v0.11    C-970.68,96.81-962.91,105.87-951.33,105.87z M-966.22,86.12c0-8.63,6.2-15.57,14.89-15.57h9.8l-2.57,1.28v23.59    c0,1.64,0.13,3.11,0.39,4.41c0.15,0.76,0.37,1.45,0.65,2.08h-8.17c-8.7,0-15-7.05-15-15.68L-966.22,86.12L-966.22,86.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-991.63,95.49 -989.8,100.31 -1016.4,66.54 -1020.55,66.54 -1020.55,105.79 -1016.23,105.79     -1016.23,76.21 -1018.69,70.49 -990.84,105.79 -987.3,105.79 -987.3,66.54 -991.63,66.54   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-931.99,168.49l24.14-23.01V129.7h-64.52v17.97h33.08l12.27-7.88l-30.63,30.75l3.28,13.34h8.73    c11.73,0,18.69,4.36,18.69,12.12v0.27c0,7.08-5.59,11.57-13.5,11.57c-9.68,0-16.5-4.08-23.05-11.44l-14.46,13.75    c8.18,9.67,20.05,16.47,37.24,16.47c21.28,0,34.37-13.21,34.37-31.18v-0.27C-906.34,177.48-919.03,170.67-931.99,168.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1047.81,65.87c-11.96,0-20.11,9.47-20.11,20.3v0.11c0,10.82,8.03,20.18,20,20.18    c11.96,0,20.11-9.47,20.11-20.29v-0.11C-1027.82,75.23-1035.85,65.87-1047.81,65.87z M-1032.42,86.28    c0,8.91-6.4,16.09-15.39,16.09s-15.5-7.29-15.5-16.2v-0.11c0-8.91,6.41-16.09,15.39-16.09c8.99,0,15.5,7.29,15.5,16.2V86.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-850.05,128.06c-29.46,0-50.88,22.19-50.88,49.28v0.27c0,27.09,21.14,49.01,50.6,49.01    c29.46,0,50.88-22.19,50.88-49.28v-0.27C-799.44,149.98-820.59,128.06-850.05,128.06z M-821.4,177.61    c0,16.34-11.73,29.68-28.65,29.68c-16.91,0-28.92-13.61-28.92-29.95v-0.27c0-16.34,11.73-29.68,28.64-29.68    c16.91,0,28.92,13.61,28.92,29.95v0.27H-821.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1080.02,
    y: 66.54,
    className: "st1",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1151.3,214.1l4.05-3.12l20.87-16.08c16.91-13.07,25.1-20.96,25.1-36.89v-0.27    c0-17.84-13.09-29.41-32.87-29.41c-17.05,0-26.19,6.94-35.6,19.74l14.73,11.84c7.09-8.71,12.14-12.79,19.51-12.79    c7.5,0,12.82,4.36,12.82,12.39c0,7.89-4.64,13.07-16.5,22.87l-31.78,26v16.61h70.66v-18.11h-36.41L-1151.3,214.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1151.01,106.07 -1134.11,66.54 -1138.88,66.54 -1152.24,98.71 -1151.82,103.03 -1152.92,100.35     -1164.49,72.39 -1166.91,66.54 -1171.85,66.54 -1154.94,106.07   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1128.08,
    y: 66.54,
    className: "st1",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1100.14,84.03c-8.65-1.85-10.67-3.92-10.67-7.62V76.3c0-3.53,3.26-6.33,8.37-6.33    c4.04,0,7.7,1.29,11.35,4.26l2.58-3.42c-3.99-3.2-8.09-4.82-13.82-4.82c-7.47,0-12.92,4.54-12.92,10.71v0.11    c0,6.45,4.16,9.36,13.2,11.33c8.26,1.74,10.22,3.81,10.22,7.46v0.11c0,3.87-3.48,6.67-8.76,6.67c-5.45,0-9.38-1.85-13.48-5.55    l-2.75,3.25c4.72,4.21,9.83,6.28,16.06,6.28c7.81,0,13.42-4.37,13.42-11.1v-0.11C-1087.34,89.14-1091.38,85.94-1100.14,84.03z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1043.26,121.79 -1038.42,126.42 -1043.06,131.25 -1047.9,126.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1032.19,126.62 -1027.36,131.25 -1022.72,126.42 -1027.55,121.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1039,132.7 -1035.23,136.31 -1031.62,132.55 -1035.39,128.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1025.19,134.76 -1021.43,138.37 -1017.82,134.61 -1021.58,131.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1045.16,138.44 -1041.39,142.05 -1037.78,138.29 -1041.54,134.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1032.52,138.88 -1028.76,142.49 -1025.15,138.73 -1028.91,135.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1037.46,143.2 -1034.82,145.74 -1032.27,143.1 -1034.92,140.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1027.47,145.2 -1024.83,147.73 -1022.28,145.09 -1024.93,142.55  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1004.96,
    y: 124.28,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -39.5611 -178.3376)",
    className: "st1",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1015.79,
    y: 127.84,
    transform: "matrix(0.9836 -0.1801 0.1801 0.9836 -40.1834 -180.2035)",
    className: "st1",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1003.09,
    y: 137.06,
    transform: "matrix(0.9836 -0.1804 0.1804 0.9836 -41.7306 -178.0486)",
    className: "st1",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1012.28,
    y: 138.12,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -41.8884 -179.6433)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1002.29,
    y: 147.85,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -43.4781 -177.6839)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1019.96,
    y: 140.21,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -42.3909 -180.9946)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1010.64,
    y: 146.92,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -43.4474 -179.2053)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1017.34,
    y: 147.69,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -43.601 -180.6464)",
    className: "st1",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1010.4,
    y: 155.14,
    transform: "matrix(0.9837 -0.1798 0.1798 0.9837 -44.6593 -178.7833)",
    className: "st1",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-981.22,151.95 -984.81,159.48 -977.27,163.06 -973.68,155.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-991.93,148.47 -994.81,154.51 -988.76,157.39 -985.88,151.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-986.98,163.35 -989.86,169.39 -983.8,172.26 -980.92,166.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-994.91,158.82 -997.15,163.53 -992.44,165.76 -990.19,161.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-992.51,172.55 -994.76,177.25 -990.05,179.49 -987.8,174.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1002.37,156.02 -1004.61,160.73 -999.9,162.96 -997.65,158.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-998.74,166.9 -1000.98,171.61 -996.27,173.84 -994.03,169.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1004.41,163.59 -1005.99,166.9 -1002.67,168.47 -1001.1,165.16  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1004.08,
    y: 174.33,
    transform: "matrix(0.4297 -0.903 0.903 0.4297 -730.6656 -804.5446)",
    className: "st1",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-977.16,188.01 -984.48,192.01 -980.46,199.32 -973.14,195.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-983.8,178.93 -989.68,182.15 -986.45,188.01 -980.58,184.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-988.51,193.89 -994.38,197.11 -991.16,202.97 -985.28,199.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-992.28,185.58 -996.86,188.09 -994.35,192.65 -989.77,190.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-998.39,198.11 -1002.96,200.62 -1000.45,205.18 -995.88,202.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-996.69,178.96 -1001.26,181.46 -998.76,186.03 -994.18,183.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1000.13,189.9 -1004.71,192.4 -1002.2,196.97 -997.62,194.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1002.78,183.9 -1006,185.66 -1004.23,188.87 -1001.02,187.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1007.68,192.82 -1010.9,194.58 -1009.13,197.79 -1005.91,196.03  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1003.77,
    y: 219.1,
    transform: "matrix(0.1226 -0.9925 0.9925 0.1226 -1098.6438 -796.1562)",
    className: "st1",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1002.19,
    y: 207.93,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -1085.6549 -805.9701)",
    className: "st1",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1014.77,
    y: 217.31,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -1106.0042 -810.2188)",
    className: "st1",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1011.41,
    y: 208.44,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -1094.4734 -816.0295)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1023.71,
    y: 215.03,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -1111.7991 -822.4549)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1011.08,
    y: 200.53,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -1086.028 -822.6672)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1020.29,
    y: 207.39,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -1100.9064 -825.7883)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1017.28,
    y: 201.05,
    transform: "matrix(0.1228 -0.9924 0.9924 0.1228 -1092.1046 -829.794)",
    className: "st1",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1026.45,
    y: 205.41,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -1104.5693 -835.0583)",
    className: "st1",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1027.99,234.83 -1034.11,229.16 -1039.8,235.27 -1033.68,240.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1029.12,118.05 -1035.24,112.38 -1040.93,118.49 -1034.8,124.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1021.46,225.68 -1026.37,221.13 -1030.93,226.03 -1026.02,230.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1037.16,225.94 -1042.08,221.39 -1046.64,226.29 -1041.72,230.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1030.46,219.75 -1034.28,216.2 -1037.83,220.02 -1034.01,223.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1044.3,217.91 -1048.12,214.37 -1051.67,218.18 -1047.84,221.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1025.55,213.48 -1029.37,209.94 -1032.92,213.75 -1029.1,217.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1037.04,213.67 -1040.86,210.13 -1044.41,213.94 -1040.59,217.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1032.17,209.27 -1034.86,206.77 -1037.36,209.46 -1034.67,211.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1042.19,207.44 -1044.88,204.95 -1047.38,207.63 -1044.69,210.12  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1072.76,
    y: 220.46,
    transform: "matrix(0.9805 -0.1965 0.1965 0.9805 -64.9738 -205.5979)",
    className: "st1",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1060.27,
    y: 218.34,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -64.1247 -203.2663)",
    className: "st1",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1073.21,
    y: 209.42,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -62.7493 -206.2776)",
    className: "st1",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1062.48,
    y: 209.58,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -62.3165 -204.0316)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1054.82,
    y: 207.36,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -61.733 -202.5702)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1064.25,
    y: 200.82,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -60.6304 -204.5497)",
    className: "st1",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1056.12,
    y: 201.45,
    transform: "matrix(0.9806 -0.1962 0.1962 0.9806 -60.3713 -202.8928)",
    className: "st1",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1063.16,
    y: 194.12,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -59.2759 -204.928)",
    className: "st1",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1088.55,201.45 -1085.08,193.86 -1092.69,190.41 -1096.15,197.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1077.78,204.75 -1075.01,198.67 -1081.1,195.89 -1083.88,201.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1082.98,189.96 -1080.2,183.87 -1086.3,181.1 -1089.08,187.19  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1078.84,
    y: 188.24,
    transform: "matrix(0.4149 -0.9099 0.9099 0.4149 -803.3241 -867.5516)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1068.62,206.21 -1066.46,201.47 -1071.21,199.31 -1073.37,204.05  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1081.51,
    y: 174.63,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -792.3122 -877.8959)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1071.39,
    y: 190.99,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -801.2772 -859.116)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1075.2,
    y: 180.11,
    transform: "matrix(0.4154 -0.9096 0.9096 0.4154 -793.2352 -868.854)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1065.56,189.43 -1064.03,186.1 -1067.37,184.58 -1068.9,187.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1066.98,179.37 -1065.46,176.03 -1068.8,174.51 -1070.32,177.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1093.21,165.47 -1085.95,161.34 -1090.09,154.1 -1097.35,158.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1086.42,174.43 -1080.59,171.12 -1083.92,165.31 -1089.74,168.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1081.96,159.4 -1076.14,156.09 -1079.46,150.28 -1085.28,153.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1078.05,167.64 -1073.52,165.06 -1076.1,160.54 -1080.63,163.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1072.15,155.02 -1067.62,152.44 -1070.2,147.91 -1074.74,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1073.53,174.19 -1069,171.61 -1071.58,167.09 -1076.12,169.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1070.27,163.2 -1065.74,160.62 -1068.32,156.09 -1072.86,158.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1067.52,169.15 -1064.33,167.34 -1066.15,164.16 -1069.34,165.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1062.77,160.16 -1059.58,158.34 -1061.4,155.16 -1064.59,156.97  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1075.49,
    y: 125.66,
    transform: "matrix(0.1063 -0.9943 0.9943 0.1063 -1086.528 -949.2187)",
    className: "st1",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1075.3,
    y: 138.46,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -1098.9034 -939.1543)",
    className: "st1",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1062.87,
    y: 128.87,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -1078.2542 -935.3579)",
    className: "st1",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1064.66,
    y: 139.25,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -1090.0039 -929.2661)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1052.38,
    y: 132.51,
    transform: "matrix(0.1061 -0.9944 0.9944 0.1061 -1072.757 -923.0677)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1064.8,
    y: 147.2,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -1098.027 -922.2911)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1055.71,
    y: 140.19,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -1082.9349 -919.5262)",
    className: "st1",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1057.04,
    y: 148.08,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -1091.9952 -915.2593)",
    className: "st1",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1047.94,
    y: 143.59,
    transform: "matrix(0.1058 -0.9944 0.9944 0.1058 -1080.0358 -910.1968)",
    className: "st1",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1008.68,181.78c-0.62-0.35-1.75-0.94-3.31-1.43c-2.25-0.72-5.39-1.26-9.11-0.67   c-1.25,0.2-2.57,0.53-3.94,1.02c-0.13,0.05-0.26,0.09-0.39,0.14c-0.7,0.26-1.39,0.58-2.09,0.93c-0.59,0.3-1.19,0.63-1.78,0.99   c-1.35,0.81-2.68,1.73-3.97,2.73c-1.47-8.89-0.75-17.14-0.41-21.19c0-0.02,0.03-0.03,0.05-0.02c3.15,1.98,2.27,7.51,1.6,9.1   c-0.01,0.03,0.03,0.05,0.06,0.03c3.92-4.63,2.01-9.75,1.2-11.04c-0.02-0.03,0.02-0.06,0.05-0.04c0.57,0.46,1.03,0.95,1.42,1.45   c1.21,1.55,1.66,3.22,1.78,4.7c0.06,0.78,0.04,1.5,0,2.12c-0.01,0.17-0.02,0.32-0.04,0.47c0,0.02,0.02,0.03,0.04,0.02   c0.01,0,0.02,0,0.02-0.01c1.06-2.08,1.57-5.22-0.02-8.27c-0.43-0.83-1.01-1.65-1.78-2.44c-0.22-0.23-0.46-0.45-0.71-0.68   c-0.02-0.02,0-0.06,0.03-0.05c0.24,0.06,0.46,0.13,0.68,0.2c0.67,0.23,1.26,0.55,1.78,0.94c1.19,0.88,2,2.08,2.48,3.34   c0.4,1.04,0.58,2.11,0.58,3.06c0,0.04,0.05,0.04,0.06,0.01c0.74-2.71,0.29-4.76-0.64-6.25c-0.66-1.07-1.57-1.85-2.48-2.4   c-0.62-0.37-1.24-0.63-1.78-0.79c-0.32-0.1-0.6-0.16-0.85-0.19c-0.04,0-0.03-0.06,0.01-0.06c0.29-0.03,0.57-0.04,0.84-0.05   c0.66-0.01,1.25,0.05,1.78,0.14c1.05,0.2,1.87,0.56,2.48,0.98c1,0.67,1.5,1.46,1.67,1.78c0.02,0.03,0.06,0.01,0.06-0.02   c-0.14-1.43-0.8-2.55-1.72-3.35c-0.71-0.62-1.58-1.05-2.48-1.31c-0.59-0.16-1.19-0.25-1.78-0.26c-0.8-0.01-1.57,0.12-2.22,0.4   c-0.03,0.01-0.05-0.02-0.04-0.05c0.58-0.83,1.4-1.33,2.26-1.6c0.6-0.18,1.21-0.25,1.78-0.21c0.55,0.03,1.05,0.15,1.46,0.34   c0.03,0.01,0.05-0.02,0.03-0.05c-0.45-0.51-0.96-0.91-1.49-1.21c-0.57-0.32-1.17-0.51-1.78-0.58c-1.59-0.18-3.21,0.5-4.29,2.13   c-0.01,0.02-0.04,0.02-0.05,0c-0.21-0.37-0.41-0.78-0.59-1.21c-0.43-1-0.78-2.12-0.97-3.24c-0.01-0.04-0.05-0.04-0.05,0   c-0.19,1.12-0.55,2.25-0.98,3.25c-0.19,0.43-0.38,0.83-0.59,1.19c-0.01,0.02-0.04,0.02-0.05,0c-1.88-2.85-5.41-2.79-7.56-0.33   c-0.02,0.02,0,0.06,0.03,0.05c1.43-0.68,4.14-0.48,5.5,1.47c0.02,0.03-0.01,0.06-0.04,0.05c-2.09-0.88-5.33-0.31-7.06,1.75   c-0.62,0.73-1.04,1.66-1.15,2.77c0,0.03,0.04,0.05,0.06,0.02c0.13-0.25,0.47-0.79,1.09-1.34c1.01-0.89,2.77-1.79,5.68-1.52   c0.04,0.01,0.04,0.06,0.01,0.06c-1.49,0.18-4.56,1.51-5.69,4.55c-0.5,1.34-0.63,3.02-0.07,5.08c0.01,0.03,0.06,0.03,0.06-0.01   c0-0.05,0-0.09,0.01-0.14c0.03-2.76,1.61-6.46,5.52-7.4c0.03-0.01,0.05,0.03,0.03,0.05c-4.37,3.84-3.94,8.58-2.51,11.38   c0.02,0.03,0.06,0.02,0.06-0.01c-0.19-2.12-0.34-5.89,3.16-8.74c0.03-0.02,0.07,0.01,0.05,0.04c-0.81,1.3-2.72,6.41,1.2,11.04   c0.02,0.03,0.07,0.01,0.06-0.03c-0.66-1.58-1.54-7.12,1.6-9.1c0.02-0.01,0.05,0,0.05,0.02c0.34,4.05,1.06,12.3-0.41,21.19   c-2.53-1.94-5.2-3.64-7.84-4.64c-0.33-0.12-0.65-0.23-0.96-0.34c-2.73-0.9-5.23-1.15-7.41-1.05c-3.5,0.15-6.18,1.2-7.65,1.93   c-0.3,0.15-0.55,0.29-0.74,0.4c-0.08,0.05-0.02,0.16,0.06,0.13c0.23-0.07,0.45-0.14,0.68-0.2c2.69-0.76,5.24-0.96,7.65-0.75   c2.63,0.23,5.1,0.95,7.41,1.99c3.24,1.46,6.17,3.54,8.82,5.74c-3.74,3.26-6.9,6.43-8.82,7.54c-0.1,0.05-0.19,0.11-0.28,0.16   c-0.46-0.63-1.26-0.99-2.13-0.8c-0.76,0.17-1.38,0.78-1.55,1.53c-0.15,0.67,0.02,1.4,0.4,1.78c1.02,1.02,2.2,1.09,3.56,0.52   c2.59-1.09,5.81-4.51,9.76-8.13c0.33-0.3,0.66-0.61,1-0.91c0.34,0.3,0.67,0.6,1,0.9c1.79,1.64,3.43,3.24,4.93,4.6   c0.62,0.56,1.21,1.08,1.78,1.54c0.88,0.72,1.71,1.31,2.48,1.72c1.51,0.8,2.82,0.9,3.94-0.09c0.06-0.05,0.12-0.1,0.18-0.16   c0.26-0.26,0.56-1.11,0.4-1.78c-0.09-0.39-0.3-0.74-0.59-1.01c-0.26-0.25-0.6-0.44-0.96-0.52c-0.87-0.19-1.67,0.17-2.13,0.8   c-0.26-0.13-0.54-0.31-0.85-0.52c-0.71-0.49-1.54-1.18-2.48-2c-0.56-0.49-1.15-1.03-1.78-1.6c-1.22-1.11-2.56-2.33-3.98-3.58   c1.26-1.05,2.59-2.07,3.98-3.01c0.58-0.39,1.17-0.77,1.78-1.13c0.81-0.48,1.63-0.92,2.48-1.33c1.27-0.61,2.58-1.12,3.94-1.51   c2.82-0.81,5.85-1.08,9.11-0.56c1.06,0.17,2.14,0.42,3.25,0.76C-1008.66,181.94-1008.6,181.83-1008.68,181.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1152.46,
    y: 272.59,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-986.83,269.75v-16.24h-2.4v13.84h-9.05v-13.84h-2.4v13.84h-9.53v-13.84h-3.77c-1.5,0-2.86,0.2-4.08,0.61    c-1.22,0.41-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65    s1.26,1.85,2.16,2.51c0.9,0.66,1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.78,0.48L-986.83,269.75L-986.83,269.75z M-1017.5,266.97    c-0.79-0.26-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79c-0.34-0.71-0.51-1.51-0.51-2.41c0-0.86,0.19-1.64,0.56-2.35    s0.86-1.31,1.47-1.82s1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37    C-1015.86,267.36-1016.71,267.23-1017.5,266.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1038.1,
    y: 248.29,
    className: "st1",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1012.67,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -989.26,
    y: 272.56,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1148.26,
    y: 272.59,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1047.48,267.36h-3.92c-1.4,0-2.5-0.2-3.3-0.6s-1.43-1-1.89-1.79c0.14-0.62,0.21-1.37,0.21-2.24v-7.72h-2.4    v8.1c0,1.38-0.37,2.48-1.11,3.31s-1.86,1.24-3.36,1.24c-0.7,0-1.34-0.11-1.92-0.33c-0.58-0.22-1.08-0.52-1.5-0.9    s-0.75-0.82-0.99-1.33c-0.24-0.51-0.37-1.05-0.39-1.63v-8.46h-2.4v8.28c0,0.74-0.11,1.36-0.33,1.87s-0.52,0.93-0.9,1.26    c-0.38,0.33-0.81,0.57-1.29,0.72s-0.99,0.22-1.53,0.22h-4.64v-12.35h-2.4v12.35h-12.58l4.19-10.02c-0.64-0.56-1.32-1.08-2.04-1.57    c-0.72-0.49-1.46-0.92-2.22-1.29s-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31c-0.78,0-1.56,0.11-2.34,0.31    c-0.78,0.21-1.55,0.49-2.32,0.85c-0.77,0.36-1.51,0.79-2.22,1.29s-1.37,1.02-1.99,1.58l4.22,10.02h-8.3v-13.84h-3.83    c-1.48,0-2.83,0.21-4.05,0.63c-1.22,0.42-2.26,0.99-3.13,1.72c-0.87,0.73-1.54,1.6-2.02,2.6c-0.48,1.01-0.72,2.1-0.72,3.28    c0,1.42,0.26,2.63,0.79,3.63c0.53,1.01,1.25,1.84,2.16,2.48c0.91,0.65,1.96,1.13,3.16,1.43c1.2,0.31,2.47,0.46,3.81,0.46h1.44    v0.69c0,1.26-0.36,2.15-1.08,2.69s-1.73,0.81-3.03,0.81c-0.74,0-1.4-0.07-1.99-0.21c-0.59-0.14-1.26-0.38-2.02-0.72l-0.75,2.3    c0.92,0.34,1.73,0.59,2.44,0.76s1.42,0.26,2.14,0.26c2.34,0,4.03-0.55,5.09-1.66c1.06-1.11,1.59-2.6,1.59-4.47v-0.45h37.24    c1.16,0,2.19-0.25,3.1-0.75s1.64-1.17,2.2-2c0.58,0.96,1.37,1.71,2.37,2.24c1,0.54,2.19,0.81,3.57,0.81    c1.44,0,2.66-0.25,3.67-0.75s1.78-1.26,2.32-2.3c0.2,0.34,0.44,0.67,0.73,1s0.66,0.62,1.12,0.88s1.02,0.47,1.66,0.63    c0.49,0.12,1.08,0.18,1.72,0.21v0.03h6.92v-21.46h-2.4v19.08H-1047.48z M-1114.12,267.36h-2.43c-0.9,0-1.74-0.12-2.53-0.37    s-1.48-0.61-2.08-1.09s-1.07-1.07-1.41-1.76c-0.34-0.7-0.51-1.5-0.51-2.39c0-0.86,0.18-1.64,0.55-2.36    c0.37-0.72,0.86-1.33,1.47-1.84s1.3-0.9,2.08-1.18c0.78-0.28,1.59-0.42,2.43-0.42h2.43V267.36z M-1100.9,267.36l-3.74-9.18    c0.92-0.78,1.86-1.35,2.83-1.7c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64c1.06,0.43,1.96,0.96,2.7,1.6l-3.74,9.18    H-1100.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1160.66,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -918.23,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -939.46,
    y: 248.29,
    className: "st1",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1016.87,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1129.28,260.34c0-0.94-0.12-1.81-0.38-2.63c-0.25-0.82-0.63-1.51-1.15-2.09c-0.64-0.7-1.35-1.22-2.14-1.57    s-1.75-0.52-2.89-0.52h-1.77v2.39h2.1c0.58,0,1.13,0.13,1.65,0.37c0.52,0.25,0.95,0.57,1.29,0.97c0.34,0.42,0.57,0.88,0.7,1.38    s0.2,1.1,0.2,1.79v6.94h-11.24v2.39h13.63L-1129.28,260.34L-1129.28,260.34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -812.66,
    y: 248.29,
    className: "st1",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -914.03,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-819.64,248.29h-2.4v19.07h-8.24c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45    c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.32,0.23-3.36,0.69    s-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77s-0.66,2.19-0.66,3.41c0,0.64,0.07,1.25,0.2,1.84s0.3,1.15,0.52,1.69h-7.43    c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84    c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.31,0.23-3.35,0.69s-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77s-0.66,2.19-0.66,3.41    c0,0.64,0.07,1.25,0.2,1.84s0.3,1.15,0.52,1.69h-7.61v-19.07h-2.4v19.07h-7.64v-3.66c0-0.92-0.12-1.79-0.36-2.62    s-0.62-1.53-1.14-2.11c-0.62-0.7-1.32-1.22-2.1-1.56c-0.78-0.34-1.77-0.51-2.97-0.51h-10.61l4.51-8.62h-2.61l-4.6,8.59    c0.08,0.52,0.2,0.97,0.38,1.35c0.17,0.38,0.4,0.74,0.7,1.08h12.22c0.76,0,1.41,0.11,1.96,0.35c0.55,0.23,0.99,0.54,1.33,0.94    s0.57,0.86,0.69,1.38c0.12,0.52,0.18,1.1,0.18,1.73v3.66h-22.17v-13.84h-3.78c-1.5,0-2.86,0.2-4.07,0.61    c-1.22,0.41-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65    s1.26,1.85,2.16,2.51c0.9,0.66,1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.77,0.48h47.55c0.78,0.84,1.7,1.5,2.77,1.99    s2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72c1.11-0.48,2.06-1.15,2.86-2h10.55c0.78,0.84,1.7,1.5,2.77,1.99    s2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72c1.11-0.48,2.06-1.15,2.86-2h12.19L-819.64,248.29L-819.64,248.29z     M-913.96,267.36h-2.37c-0.9,0-1.74-0.13-2.53-0.39c-0.79-0.26-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79    c-0.34-0.71-0.51-1.51-0.51-2.41c0-0.86,0.18-1.64,0.55-2.35s0.86-1.31,1.47-1.82s1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4    h2.37L-913.96,267.36L-913.96,267.36z M-855.67,266.3c-0.33,0.77-0.78,1.43-1.35,1.99c-0.57,0.56-1.24,0.99-2.01,1.3    s-1.6,0.46-2.5,0.46c-0.88,0-1.69-0.17-2.44-0.49c-0.75-0.33-1.4-0.78-1.95-1.35s-0.98-1.23-1.29-1.99    c-0.31-0.76-0.46-1.57-0.46-2.42c0-0.86,0.16-1.67,0.46-2.44c0.31-0.77,0.74-1.43,1.28-2c0.54-0.57,1.18-1.02,1.93-1.36    s1.57-0.51,2.47-0.51c0.92,0,1.76,0.16,2.53,0.48s1.44,0.76,2.01,1.32s1.01,1.22,1.33,1.99s0.48,1.61,0.48,2.53    C-855.17,264.7-855.34,265.53-855.67,266.3z M-832.42,266.3c-0.33,0.77-0.78,1.43-1.35,1.99c-0.57,0.56-1.24,0.99-2.01,1.3    s-1.6,0.46-2.5,0.46c-0.88,0-1.69-0.17-2.44-0.49c-0.75-0.33-1.4-0.78-1.95-1.35s-0.98-1.23-1.29-1.99    c-0.31-0.76-0.47-1.57-0.47-2.42c0-0.86,0.16-1.67,0.47-2.44s0.73-1.43,1.27-2c0.54-0.57,1.18-1.02,1.93-1.36s1.57-0.51,2.47-0.51    c0.92,0,1.76,0.16,2.53,0.48s1.44,0.76,2.01,1.32s1.01,1.22,1.33,1.99s0.48,1.61,0.48,2.53    C-831.92,264.7-832.09,265.53-832.42,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1165.74,269.27c1.2,0.32,2.46,0.48,3.77,0.48h15.7v-16.24h-2.4v13.84h-9.53v-13.84h-3.78    c-1.5,0-2.85,0.2-4.07,0.61s-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65    s1.26,1.85,2.16,2.51C-1167.99,268.47-1166.94,268.96-1165.74,269.27z M-1169.46,261.65c0-0.86,0.19-1.64,0.56-2.35    c0.37-0.71,0.86-1.31,1.47-1.82s1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37c-0.9,0-1.74-0.13-2.53-0.39    s-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79C-1169.29,263.35-1169.46,262.55-1169.46,261.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -998.02,
    y: 272.59,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1002.22,
    y: 272.59,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-977.5,272.79c0.15-0.75,0.23-1.59,0.23-2.53v-0.51h30.83v-21.46h-2.4v19.07h-10.19l4.19-10.02    c-0.64-0.56-1.32-1.08-2.04-1.57c-0.72-0.49-1.46-0.92-2.22-1.29c-0.76-0.37-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31    c-0.78,0-1.56,0.11-2.34,0.31c-0.78,0.21-1.55,0.49-2.32,0.85s-1.51,0.79-2.22,1.29c-0.71,0.5-1.37,1.02-1.99,1.58l4.22,10.02    h-8.93v-13.84h-2.4v16.75c0,0.68-0.03,1.25-0.1,1.72c-0.07,0.47-0.19,0.85-0.36,1.14s-0.4,0.5-0.69,0.63s-0.66,0.2-1.12,0.2    c-0.22,0-0.41-0.01-0.57-0.03c-0.16-0.02-0.38-0.07-0.66-0.15l-0.63,2.3c0.66,0.18,1.31,0.27,1.95,0.27    c0.86,0,1.58-0.14,2.17-0.42c0.59-0.28,1.06-0.68,1.42-1.21C-977.9,274.18-977.65,273.54-977.5,272.79z M-969.57,258.18    c0.92-0.78,1.86-1.35,2.83-1.7c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64s1.96,0.96,2.7,1.6l-3.74,9.18h-4.28    L-969.57,258.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1164.86,
    y: 248.29,
    className: "st1",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1154.66,285.47 -1158.35,285.47 -1166.5,294.07 -1166.5,285.47 -1169.51,285.47 -1169.51,302.56     -1166.5,302.56 -1166.5,297.61 -1163.83,294.87 -1157.99,302.56 -1154.34,302.56 -1161.78,292.82   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1151.6,
    y: 285.47,
    className: "st1",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1132,297.29 -1141.17,285.47 -1143.96,285.47 -1143.96,302.56 -1141,302.56 -1141,290.4     -1131.56,302.56 -1129.04,302.56 -1129.04,285.47 -1132,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1116.58,295.63h4.38v3.2c-1.05,0.78-2.52,1.29-4.13,1.29c-3.5,0-5.82-2.59-5.82-6.1v-0.05    c0-3.27,2.39-6.03,5.55-6.03c2.18,0,3.47,0.71,4.79,1.83l1.91-2.27c-1.76-1.49-3.6-2.32-6.58-2.32c-5.16,0-8.83,4.05-8.83,8.84    v0.05c0,4.98,3.52,8.79,8.88,8.79c3.03,0,5.46-1.22,7.14-2.66v-7.18h-7.29L-1116.58,295.63L-1116.58,295.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1098.76,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05    C-1089.66,289.16-1093.38,285.47-1098.76,285.47z M-1092.81,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37    c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1077.86,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79s8.98-4.03,8.98-8.84v-0.05    C-1068.94,289.16-1072.61,285.18-1077.86,285.18z M-1072.09,294.07c0,3.32-2.37,6.03-5.77,6.03s-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03s5.82,2.76,5.82,6.08V294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1056.79,293.55 -1062,285.47 -1065.2,285.47 -1065.2,302.56 -1062.24,302.56 -1062.24,290.36     -1056.88,298.36 -1056.79,298.36 -1051.38,290.31 -1051.38,302.56 -1048.37,302.56 -1048.37,285.47 -1051.58,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1028.41,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79s8.98-4.03,8.98-8.84v-0.05    C-1019.48,289.16-1023.15,285.18-1028.41,285.18z M-1022.64,294.07c0,3.32-2.37,6.03-5.77,6.03s-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03s5.82,2.76,5.82,6.08L-1022.64,294.07L-1022.64,294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-1015.74,302.56 -1012.73,302.56 -1012.73,295.6 -1004.1,295.6 -1004.1,292.87 -1012.73,292.87     -1012.73,288.21 -1003,288.21 -1003,285.47 -1015.74,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-985.75,292.65c-3.28-0.78-4.06-1.37-4.06-2.68v-0.05c0-1.12,1.03-2.03,2.79-2.03    c1.57,0,3.11,0.61,4.65,1.76l1.61-2.27c-1.74-1.39-3.72-2.15-6.21-2.15c-3.4,0-5.85,2.03-5.85,4.95v0.05c0,3.15,2.06,4.22,5.7,5.1    c3.18,0.73,3.86,1.39,3.86,2.61V298c0,1.3-1.17,2.15-3.03,2.15c-2.13,0-3.77-0.81-5.41-2.22l-1.81,2.15    c2.06,1.83,4.52,2.73,7.14,2.73c3.6,0,6.11-1.9,6.11-5.1v-0.05C-980.25,294.82-982.13,293.53-985.75,292.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-971.03,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-971.03z M-972.62,295.78    l2.94-6.84l2.96,6.84H-972.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-947.3,295.31c0,3.15-1.64,4.76-4.31,4.76c-2.69,0-4.33-1.71-4.33-4.88v-9.72h-3.01v9.84    c0,4.95,2.84,7.52,7.29,7.52c4.48,0,7.36-2.56,7.36-7.66v-9.69h-3.01v9.83H-947.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-933.5,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05C-924.4,289.16-928.12,285.47-933.5,285.47z     M-927.56,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -920.59,
    y: 285.47,
    className: "st1",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-899.61,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-899.61z M-901.2,295.78    l2.94-6.84l2.96,6.84H-901.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-872.45,290.92v-0.05c0-1.49-0.51-2.76-1.42-3.69c-1.1-1.07-2.79-1.71-4.94-1.71h-7.63v17.09h3.01v-5.96    h3.72h0.05l4.21,5.96h3.55l-4.62-6.47C-874.14,295.41-872.45,293.72-872.45,290.92z M-883.43,293.94v-5.74h4.38    c2.23,0,3.55,1,3.55,2.83v0.05c0,1.73-1.37,2.86-3.52,2.86L-883.43,293.94L-883.43,293.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-862.17,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-862.17z M-863.76,295.78    l2.94-6.84l2.96,6.84H-863.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-838.15,293.68c1.27-0.66,2.45-1.76,2.45-3.81v-0.05c0-1.15-0.39-2.07-1.15-2.83    c-0.98-0.98-2.52-1.51-4.48-1.51h-7.68v17.09h7.92c3.82,0,6.33-1.63,6.33-4.69v-0.05C-834.75,295.51-836.14,294.36-838.15,293.68z     M-846.05,288.13h4.33c1.93,0,3.01,0.83,3.01,2.17v0.05c0,1.56-1.3,2.32-3.23,2.32h-4.11L-846.05,288.13L-846.05,288.13z     M-837.76,297.56c0,1.54-1.25,2.34-3.3,2.34h-4.99v-4.69h4.77c2.37,0,3.52,0.86,3.52,2.3L-837.76,297.56L-837.76,297.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -831.02,
    y: 285.47,
    className: "st1",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-814.82,285.35h-2.79l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18L-814.82,285.35z M-819.2,295.78    l2.94-6.84l2.96,6.84H-819.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -309.47,
    y: 58.23,
    className: "st0",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: -222.38,
    y: 110.2,
    className: "st0",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-171.47,105.72c1.03-0.49,1.86-1.19,2.49-2.12c0.63-0.92,1.07-2.04,1.33-3.34c0.26-1.31,0.39-2.78,0.39-4.41    V66.59h-4.19v29.26c0,1.18-0.06,2.18-0.18,3s-0.33,1.48-0.63,1.99c-0.3,0.5-0.7,0.87-1.2,1.1c-0.51,0.23-1.16,0.34-1.96,0.34    c-0.38,0-0.72-0.02-0.99-0.05c-0.28-0.03-0.66-0.12-1.15-0.26l-1.1,4.02c1.15,0.32,2.29,0.47,3.4,0.47    C-173.77,106.45-172.5,106.21-171.47,105.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-185.87,59.18h-5.75v-0.97c0-0.53,0.11-0.94,0.34-1.23c0.19-0.24,0.64-0.36,1.29-0.36h2.88v-2.91h-2.95    c-1.6,0-2.85,0.42-3.69,1.25c-0.85,0.83-1.28,2.19-1.28,4.02v3.41h9.17L-185.87,59.18L-185.87,59.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -230.76,
    y: 110.2,
    className: "st0",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: -301.09,
    y: 58.23,
    className: "st0",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-204.74,91.64c1.59,1.13,3.43,1.97,5.52,2.51c2.09,0.54,4.31,0.81,6.65,0.81h1.11l1.41-2.95v4.15    c0,2.19-0.63,3.76-1.88,4.7c-1.26,0.94-3.02,1.41-5.29,1.41c-1.29,0-2.45-0.12-3.48-0.37c-1.03-0.24-2.21-0.66-3.53-1.25    l-1.31,4.02c1.6,0.59,3.03,1.04,4.27,1.33c1.24,0.3,2.49,0.44,3.74,0.44c4.08,0,7.05-0.97,8.9-2.9c1.85-1.94,2.77-4.54,2.77-7.81    V66.59h-6.7c-2.58,0-4.94,0.37-7.07,1.1c-2.13,0.73-3.95,1.73-5.47,3s-2.7,2.79-3.53,4.55c-0.84,1.76-1.26,3.67-1.26,5.72    c0,2.47,0.46,4.59,1.39,6.35C-207.59,89.06-206.33,90.51-204.74,91.64z M-204.74,76.83c0.64-1.25,1.5-2.32,2.56-3.21    s2.28-1.57,3.64-2.06c1.32-0.47,2.69-0.71,4.11-0.72v-0.01h6.77l-2.39,1.19v18.77h-4.24c-1.57,0-3.04-0.22-4.42-0.66    c-1.38-0.43-2.59-1.07-3.64-1.91c-1.05-0.84-1.87-1.86-2.46-3.08c-0.59-1.22-0.89-2.61-0.89-4.18    C-205.71,79.46-205.39,78.08-204.74,76.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-308.33,105.87h8.7v-3.13c0.08,0.15,0.17,0.3,0.26,0.43c0.63,0.92,1.46,1.63,2.49,2.12    c1.03,0.49,2.29,0.73,3.79,0.73h76.35V66.59h-4.19v35.26h-4.35h-67.66c-0.8,0-1.46-0.11-1.96-0.34c-0.5-0.23-0.91-0.59-1.2-1.1    s-0.5-1.17-0.63-1.99c-0.12-0.82-0.18-1.82-0.18-3V66.59h-11.32c-11.58,0-19.46,9.17-19.46,19.64v0.11    C-327.68,96.81-319.91,105.87-308.33,105.87z M-323.22,86.12c0-8.63,6.2-15.57,14.89-15.57h9.8l-2.57,1.28v23.59    c0,1.64,0.13,3.11,0.39,4.41c0.15,0.76,0.37,1.45,0.65,2.08h-8.17c-8.7,0-15-7.05-15-15.68v-0.11H-323.22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-348.63,95.49 -346.8,100.31 -373.4,66.54 -377.55,66.54 -377.55,105.79 -373.23,105.79     -373.23,76.21 -375.69,70.49 -347.84,105.79 -344.3,105.79 -344.3,66.54 -348.63,66.54   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-288.99,168.49l24.14-23.01V129.7h-64.52v17.97h33.08l12.27-7.88l-30.63,30.75l3.28,13.34h8.73    c11.73,0,18.69,4.36,18.69,12.12v0.27c0,7.08-5.59,11.57-13.5,11.57c-9.68,0-16.5-4.08-23.05-11.44l-14.46,13.75    c8.18,9.67,20.05,16.47,37.24,16.47c21.28,0,34.37-13.21,34.37-31.18v-0.27C-263.34,177.48-276.03,170.67-288.99,168.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-404.81,65.87c-11.96,0-20.11,9.47-20.11,20.3v0.11c0,10.82,8.03,20.18,20,20.18    c11.96,0,20.11-9.47,20.11-20.29v-0.11C-384.82,75.23-392.85,65.87-404.81,65.87z M-389.42,86.28c0,8.91-6.4,16.09-15.39,16.09    c-8.99,0-15.5-7.29-15.5-16.2v-0.11c0-8.91,6.41-16.09,15.39-16.09c8.99,0,15.5,7.29,15.5,16.2V86.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-207.05,128.06c-29.46,0-50.88,22.19-50.88,49.28v0.27c0,27.09,21.14,49.01,50.6,49.01    s50.88-22.19,50.88-49.28v-0.27C-156.44,149.98-177.59,128.06-207.05,128.06z M-178.4,177.61c0,16.34-11.73,29.68-28.65,29.68    c-16.91,0-28.92-13.61-28.92-29.95v-0.27c0-16.34,11.73-29.68,28.64-29.68s28.92,13.61,28.92,29.95L-178.4,177.61L-178.4,177.61z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -437.02,
    y: 66.54,
    className: "st0",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-508.3,214.1l4.05-3.12l20.87-16.08c16.91-13.07,25.1-20.96,25.1-36.89v-0.27    c0-17.84-13.09-29.41-32.87-29.41c-17.05,0-26.19,6.94-35.6,19.74l14.73,11.84c7.09-8.71,12.14-12.79,19.51-12.79    c7.5,0,12.82,4.36,12.82,12.39c0,7.89-4.64,13.07-16.5,22.87l-31.78,26v16.61h70.66v-18.11h-36.41L-508.3,214.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-508.01,106.07 -491.11,66.54 -495.88,66.54 -509.24,98.71 -508.82,103.03 -509.92,100.35     -521.49,72.39 -523.91,66.54 -528.85,66.54 -511.94,106.07   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -485.08,
    y: 66.54,
    className: "st0",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-457.14,84.03c-8.65-1.85-10.67-3.92-10.67-7.62V76.3c0-3.53,3.26-6.33,8.37-6.33    c4.04,0,7.7,1.29,11.35,4.26l2.58-3.42c-3.99-3.2-8.09-4.82-13.82-4.82c-7.47,0-12.92,4.54-12.92,10.71v0.11    c0,6.45,4.16,9.36,13.2,11.33c8.26,1.74,10.22,3.81,10.22,7.46v0.11c0,3.87-3.48,6.67-8.76,6.67c-5.45,0-9.38-1.85-13.48-5.55    l-2.75,3.25c4.72,4.21,9.83,6.28,16.06,6.28c7.81,0,13.42-4.37,13.42-11.1v-0.11C-444.34,89.14-448.38,85.94-457.14,84.03z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-400.26,121.79 -395.42,126.42 -400.06,131.25 -404.9,126.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-389.19,126.62 -384.36,131.25 -379.72,126.42 -384.55,121.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-396,132.7 -392.23,136.31 -388.62,132.55 -392.39,128.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-382.19,134.76 -378.43,138.37 -374.82,134.61 -378.58,131.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-402.16,138.44 -398.39,142.05 -394.78,138.29 -398.54,134.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-389.52,138.88 -385.76,142.49 -382.15,138.73 -385.91,135.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-394.46,143.2 -391.82,145.74 -389.27,143.1 -391.92,140.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-384.47,145.2 -381.83,147.73 -379.28,145.09 -381.93,142.55  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -361.96,
    y: 124.27,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -29.0221 -62.4051)",
    className: "st0",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: -372.82,
    y: 127.85,
    transform: "matrix(0.9836 -0.1801 0.1801 0.9836 -29.6709 -64.3987)",
    className: "st0",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -360.09,
    y: 137.05,
    transform: "matrix(0.9836 -0.1804 0.1804 0.9836 -31.1793 -62.0519)",
    className: "st0",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -369.29,
    y: 138.13,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -31.3642 -63.7742)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -359.3,
    y: 147.86,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -32.9539 -61.8149)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -376.98,
    y: 140.22,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -31.8666 -65.1255)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -367.66,
    y: 146.93,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -32.9231 -63.3363)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -374.34,
    y: 147.7,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -33.0657 -64.7128)",
    className: "st0",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: -367.4,
    y: 155.15,
    transform: "matrix(0.9837 -0.1798 0.1798 0.9837 -34.183 -63.1712)",
    className: "st0",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-338.22,151.95 -341.81,159.48 -334.27,163.06 -330.68,155.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-348.93,148.47 -351.81,154.51 -345.76,157.39 -342.88,151.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-343.98,163.35 -346.86,169.39 -340.8,172.26 -337.92,166.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-351.91,158.82 -354.15,163.53 -349.44,165.76 -347.19,161.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-349.51,172.55 -351.76,177.25 -347.05,179.49 -344.8,174.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-359.37,156.02 -361.61,160.73 -356.9,162.96 -354.65,158.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-355.74,166.9 -357.99,171.61 -353.27,173.84 -351.03,169.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-361.41,163.59 -362.99,166.9 -359.67,168.47 -358.1,165.16  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -361.1,
    y: 174.3,
    transform: "matrix(0.4297 -0.903 0.903 0.4297 -363.9412 -223.9583)",
    className: "st0",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-334.16,188.01 -341.48,192.01 -337.46,199.32 -330.14,195.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-340.8,178.93 -346.68,182.15 -343.45,188.01 -337.58,184.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-345.51,193.89 -351.38,197.11 -348.16,202.97 -342.28,199.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-349.28,185.58 -353.86,188.09 -351.35,192.65 -346.77,190.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-355.39,198.11 -359.96,200.62 -357.45,205.18 -352.88,202.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-353.69,178.96 -358.26,181.46 -355.76,186.03 -351.18,183.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-357.13,189.9 -361.71,192.4 -359.2,196.97 -354.62,194.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-359.78,183.9 -363,185.66 -361.23,188.87 -358.02,187.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-364.68,192.82 -367.9,194.58 -366.13,197.79 -362.91,196.03  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -360.8,
    y: 219.07,
    transform: "matrix(0.1226 -0.9925 0.9925 0.1226 -534.4681 -158.066)",
    className: "st0",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -359.16,
    y: 207.93,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -521.7311 -167.8231)",
    className: "st0",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -371.74,
    y: 217.32,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -542.0804 -172.0719)",
    className: "st0",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -368.38,
    y: 208.47,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -530.3777 -177.8302)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -380.68,
    y: 215.06,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -547.7036 -184.2555)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -368.06,
    y: 200.53,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -522.1047 -184.5212)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -377.26,
    y: 207.39,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 -536.9832 -187.6424)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -374.26,
    y: 201.08,
    transform: "matrix(0.1228 -0.9924 0.9924 0.1228 -528.0732 -191.6222)",
    className: "st0",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: -383.45,
    y: 205.44,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 -540.5006 -196.898)",
    className: "st0",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-384.99,234.83 -391.11,229.16 -396.8,235.27 -390.68,240.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-386.12,118.05 -392.24,112.38 -397.93,118.49 -391.8,124.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-378.46,225.68 -383.37,221.13 -387.93,226.03 -383.02,230.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-394.16,225.94 -399.08,221.39 -403.64,226.29 -398.72,230.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-387.46,219.75 -391.28,216.2 -394.83,220.02 -391.01,223.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-401.3,217.91 -405.12,214.37 -408.67,218.18 -404.84,221.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-382.55,213.48 -386.37,209.94 -389.92,213.75 -386.1,217.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-394.04,213.67 -397.86,210.13 -401.41,213.94 -397.59,217.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-389.17,209.27 -391.86,206.77 -394.36,209.46 -391.67,211.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-399.19,207.44 -401.88,204.95 -404.38,207.63 -401.69,210.12  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -429.76,
    y: 220.47,
    transform: "matrix(0.9805 -0.1965 0.1965 0.9805 -52.4385 -79.2481)",
    className: "st0",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: -417.29,
    y: 218.33,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -51.5999 -76.9815)",
    className: "st0",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -430.19,
    y: 209.39,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -50.1826 -79.8011)",
    className: "st0",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: -419.5,
    y: 209.58,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -49.793 -77.7465)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -411.84,
    y: 207.36,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -49.2095 -76.2851)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -421.27,
    y: 200.82,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -48.1069 -78.2645)",
    className: "st0",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -413.09,
    y: 201.47,
    transform: "matrix(0.9806 -0.1962 0.1962 0.9806 -47.8781 -76.735)",
    className: "st0",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: -420.14,
    y: 194.13,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -46.7159 -78.4494)",
    className: "st0",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-445.55,201.45 -442.08,193.86 -449.69,190.41 -453.15,197.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-434.78,204.75 -432.01,198.67 -438.1,195.89 -440.88,201.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-439.98,189.96 -437.2,183.87 -443.3,181.1 -446.08,187.19  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -435.86,
    y: 188.27,
    transform: "matrix(0.4149 -0.9099 0.9099 0.4149 -427.1651 -282.5227)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-425.62,206.21 -423.46,201.47 -428.21,199.31 -430.37,204.05  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -438.5,
    y: 174.62,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -416.199 -292.8991)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -428.37,
    y: 190.98,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -425.164 -274.1194)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432.19,
    y: 180.14,
    transform: "matrix(0.4154 -0.9096 0.9096 0.4154 -417.367 -283.9289)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-422.56,189.43 -421.03,186.1 -424.37,184.58 -425.9,187.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-423.98,179.37 -422.46,176.03 -425.8,174.51 -427.32,177.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-450.21,165.47 -442.95,161.34 -447.09,154.1 -454.35,158.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-443.42,174.43 -437.59,171.12 -440.92,165.31 -446.74,168.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-438.96,159.4 -433.14,156.09 -436.46,150.28 -442.28,153.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-435.05,167.64 -430.52,165.06 -433.1,160.54 -437.63,163.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-429.15,155.02 -424.62,152.44 -427.2,147.91 -431.74,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-430.53,174.19 -426,171.61 -428.58,167.09 -433.12,169.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-427.27,163.2 -422.74,160.62 -425.32,156.09 -429.86,158.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-424.52,169.15 -421.33,167.34 -423.15,164.16 -426.34,165.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-419.77,160.16 -416.58,158.34 -418.4,155.16 -421.59,156.97  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432.48,
    y: 125.68,
    transform: "matrix(0.1063 -0.9943 0.9943 0.1063 -511.8991 -309.8372)",
    className: "st0",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432.31,
    y: 138.47,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -524.3381 -299.7954)",
    className: "st0",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -419.87,
    y: 128.88,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -503.6891 -295.999)",
    className: "st0",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -421.63,
    y: 139.26,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -515.4679 -289.8818)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -409.4,
    y: 132.48,
    transform: "matrix(0.1061 -0.9944 0.9944 0.1061 -497.9641 -283.7451)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -421.79,
    y: 147.21,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -523.5101 -282.9337)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -412.7,
    y: 140.2,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 -508.4187 -280.1693)",
    className: "st0",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -414.04,
    y: 148.09,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 -517.424 -275.892)",
    className: "st0",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: -404.92,
    y: 143.58,
    transform: "matrix(0.1058 -0.9944 0.9944 0.1058 -505.0445 -270.7964)",
    className: "st0",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-365.68,181.78c-0.62-0.35-1.75-0.94-3.31-1.43c-2.25-0.72-5.39-1.26-9.11-0.67   c-1.25,0.2-2.57,0.53-3.94,1.02c-0.13,0.05-0.26,0.09-0.39,0.14c-0.7,0.26-1.39,0.58-2.09,0.93c-0.6,0.3-1.19,0.63-1.78,0.99   c-1.35,0.81-2.68,1.73-3.97,2.73c-1.47-8.89-0.75-17.14-0.41-21.19c0-0.02,0.03-0.03,0.05-0.02c3.15,1.98,2.27,7.51,1.6,9.1   c-0.01,0.03,0.03,0.05,0.06,0.03c3.92-4.63,2.01-9.75,1.2-11.04c-0.02-0.03,0.02-0.06,0.05-0.04c0.57,0.46,1.03,0.95,1.42,1.45   c1.21,1.55,1.66,3.22,1.78,4.7c0.06,0.78,0.04,1.5,0,2.12c-0.01,0.17-0.02,0.32-0.04,0.47c0,0.02,0.02,0.03,0.04,0.02   c0.01,0,0.02,0,0.02-0.01c1.06-2.08,1.57-5.22-0.02-8.27c-0.43-0.83-1.01-1.65-1.78-2.44c-0.22-0.23-0.46-0.45-0.71-0.68   c-0.02-0.02,0-0.06,0.03-0.05c0.24,0.06,0.46,0.13,0.68,0.2c0.67,0.23,1.26,0.55,1.78,0.94c1.19,0.88,2,2.08,2.48,3.34   c0.4,1.04,0.58,2.11,0.58,3.06c0,0.04,0.05,0.04,0.06,0.01c0.74-2.71,0.29-4.76-0.64-6.25c-0.66-1.07-1.57-1.85-2.48-2.4   c-0.62-0.37-1.24-0.63-1.78-0.79c-0.32-0.1-0.6-0.16-0.85-0.19c-0.04,0-0.03-0.06,0.01-0.06c0.29-0.03,0.57-0.04,0.84-0.05   c0.66-0.01,1.25,0.05,1.78,0.14c1.05,0.2,1.87,0.56,2.48,0.98c1,0.67,1.5,1.46,1.67,1.78c0.01,0.03,0.06,0.01,0.06-0.02   c-0.14-1.43-0.8-2.55-1.72-3.35c-0.71-0.62-1.58-1.05-2.48-1.31c-0.59-0.16-1.19-0.25-1.78-0.26c-0.8-0.01-1.57,0.12-2.22,0.4   c-0.03,0.01-0.05-0.02-0.04-0.05c0.58-0.83,1.4-1.33,2.26-1.6c0.6-0.18,1.21-0.25,1.78-0.21c0.55,0.03,1.05,0.15,1.46,0.34   c0.03,0.01,0.05-0.02,0.03-0.05c-0.45-0.51-0.96-0.91-1.49-1.21c-0.57-0.32-1.17-0.51-1.78-0.58c-1.59-0.18-3.21,0.5-4.29,2.13   c-0.01,0.02-0.04,0.02-0.05,0c-0.21-0.37-0.41-0.78-0.59-1.21c-0.43-1-0.78-2.12-0.97-3.24c-0.01-0.04-0.05-0.04-0.05,0   c-0.19,1.12-0.55,2.25-0.98,3.25c-0.19,0.43-0.38,0.83-0.59,1.19c-0.01,0.02-0.04,0.02-0.05,0c-1.88-2.85-5.41-2.79-7.56-0.33   c-0.02,0.02,0,0.06,0.03,0.05c1.43-0.68,4.14-0.48,5.5,1.47c0.02,0.03-0.01,0.06-0.04,0.05c-2.09-0.88-5.33-0.31-7.06,1.75   c-0.62,0.73-1.04,1.66-1.15,2.77c0,0.03,0.04,0.05,0.06,0.02c0.13-0.25,0.47-0.79,1.09-1.34c1.01-0.89,2.77-1.79,5.68-1.52   c0.04,0.01,0.04,0.06,0.01,0.06c-1.49,0.18-4.56,1.51-5.69,4.55c-0.5,1.34-0.63,3.02-0.07,5.08c0.01,0.03,0.06,0.03,0.06-0.01   c0-0.05,0-0.09,0.01-0.14c0.03-2.76,1.61-6.46,5.52-7.4c0.03-0.01,0.05,0.03,0.03,0.05c-4.37,3.84-3.94,8.58-2.51,11.38   c0.02,0.03,0.06,0.02,0.06-0.01c-0.19-2.12-0.34-5.89,3.16-8.74c0.03-0.02,0.07,0.01,0.05,0.04c-0.81,1.3-2.72,6.41,1.2,11.04   c0.02,0.03,0.07,0.01,0.06-0.03c-0.66-1.58-1.54-7.12,1.6-9.1c0.02-0.01,0.05,0,0.05,0.02c0.34,4.05,1.06,12.3-0.41,21.19   c-2.53-1.94-5.2-3.64-7.84-4.64c-0.33-0.12-0.65-0.23-0.96-0.34c-2.73-0.9-5.23-1.15-7.41-1.05c-3.5,0.15-6.18,1.2-7.65,1.93   c-0.3,0.15-0.55,0.29-0.74,0.4c-0.08,0.05-0.02,0.16,0.06,0.13c0.23-0.07,0.45-0.14,0.68-0.2c2.69-0.76,5.24-0.96,7.65-0.75   c2.63,0.23,5.1,0.95,7.41,1.99c3.24,1.46,6.17,3.54,8.82,5.74c-3.74,3.26-6.9,6.43-8.82,7.54c-0.1,0.05-0.19,0.11-0.28,0.16   c-0.46-0.63-1.26-0.99-2.13-0.8c-0.76,0.17-1.38,0.78-1.55,1.53c-0.15,0.67,0.02,1.4,0.4,1.78c1.02,1.02,2.2,1.09,3.56,0.52   c2.59-1.09,5.81-4.51,9.76-8.13c0.33-0.3,0.66-0.61,1-0.91c0.34,0.3,0.67,0.6,1,0.9c1.79,1.64,3.43,3.24,4.93,4.6   c0.62,0.56,1.21,1.08,1.78,1.54c0.88,0.72,1.71,1.31,2.48,1.72c1.51,0.8,2.82,0.9,3.94-0.09c0.06-0.05,0.12-0.1,0.18-0.16   c0.26-0.26,0.56-1.11,0.4-1.78c-0.09-0.39-0.3-0.74-0.59-1.01c-0.26-0.25-0.6-0.44-0.96-0.52c-0.87-0.19-1.67,0.17-2.13,0.8   c-0.26-0.13-0.54-0.31-0.85-0.52c-0.71-0.49-1.54-1.18-2.48-2c-0.56-0.49-1.15-1.03-1.78-1.6c-1.22-1.11-2.56-2.33-3.98-3.58   c1.26-1.05,2.59-2.07,3.98-3.01c0.58-0.39,1.17-0.77,1.78-1.13c0.81-0.48,1.63-0.92,2.48-1.33c1.27-0.61,2.58-1.12,3.94-1.51   c2.82-0.81,5.85-1.08,9.11-0.56c1.06,0.17,2.14,0.42,3.25,0.76C-365.66,181.94-365.6,181.83-365.68,181.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -509.46,
    y: 272.59,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-343.83,269.75v-16.24h-2.4v13.84h-9.05v-13.84h-2.4v13.84h-9.53v-13.84h-3.77c-1.5,0-2.86,0.2-4.08,0.61    s-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65s1.26,1.85,2.16,2.51    s1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.78,0.48L-343.83,269.75L-343.83,269.75z M-374.5,266.97    c-0.79-0.26-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79c-0.34-0.71-0.51-1.51-0.51-2.41c0-0.86,0.19-1.64,0.56-2.35    s0.86-1.31,1.47-1.82c0.61-0.51,1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37    C-372.86,267.36-373.71,267.23-374.5,266.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -395.1,
    y: 248.29,
    className: "st0",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -369.67,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -346.26,
    y: 272.56,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -505.26,
    y: 272.59,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-404.48,267.36h-3.92c-1.4,0-2.5-0.2-3.3-0.6s-1.43-1-1.89-1.79c0.14-0.62,0.21-1.37,0.21-2.24v-7.72h-2.4    v8.1c0,1.38-0.37,2.48-1.11,3.31s-1.86,1.24-3.36,1.24c-0.7,0-1.34-0.11-1.92-0.33c-0.58-0.22-1.08-0.52-1.5-0.9    s-0.75-0.82-0.99-1.33c-0.24-0.51-0.37-1.05-0.39-1.63v-8.46h-2.4v8.28c0,0.74-0.11,1.36-0.33,1.87s-0.52,0.93-0.9,1.26    c-0.38,0.33-0.81,0.57-1.29,0.72s-0.99,0.22-1.53,0.22h-4.64v-12.35h-2.4v12.35h-12.58l4.19-10.02c-0.64-0.56-1.32-1.08-2.04-1.57    c-0.72-0.49-1.46-0.92-2.22-1.29s-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31c-0.78,0-1.56,0.11-2.34,0.31    c-0.78,0.21-1.55,0.49-2.32,0.85c-0.77,0.36-1.51,0.79-2.22,1.29s-1.37,1.02-1.99,1.58l4.22,10.02h-8.3v-13.84h-3.83    c-1.48,0-2.83,0.21-4.05,0.63s-2.26,0.99-3.13,1.72c-0.87,0.73-1.54,1.6-2.02,2.6c-0.48,1.01-0.72,2.1-0.72,3.28    c0,1.42,0.26,2.63,0.79,3.63c0.53,1.01,1.25,1.84,2.16,2.48c0.91,0.65,1.96,1.13,3.16,1.43c1.2,0.31,2.47,0.46,3.81,0.46h1.44    v0.69c0,1.26-0.36,2.15-1.08,2.69s-1.73,0.81-3.03,0.81c-0.74,0-1.4-0.07-1.99-0.21c-0.59-0.14-1.26-0.38-2.02-0.72l-0.75,2.3    c0.92,0.34,1.73,0.59,2.44,0.76s1.42,0.26,2.14,0.26c2.34,0,4.03-0.55,5.09-1.66c1.06-1.11,1.59-2.6,1.59-4.47v-0.45h37.24    c1.16,0,2.19-0.25,3.1-0.75s1.64-1.17,2.2-2c0.58,0.96,1.37,1.71,2.37,2.24c1,0.54,2.19,0.81,3.57,0.81    c1.44,0,2.66-0.25,3.67-0.75s1.78-1.26,2.32-2.3c0.2,0.34,0.44,0.67,0.73,1s0.66,0.62,1.12,0.88s1.02,0.47,1.66,0.63    c0.49,0.12,1.08,0.18,1.72,0.21v0.03h6.92v-21.46h-2.4v19.08H-404.48z M-471.12,267.36h-2.43c-0.9,0-1.74-0.12-2.53-0.37    s-1.48-0.61-2.08-1.09c-0.6-0.48-1.07-1.07-1.41-1.76c-0.34-0.7-0.51-1.5-0.51-2.39c0-0.86,0.18-1.64,0.55-2.36    c0.37-0.72,0.86-1.33,1.47-1.84c0.61-0.51,1.3-0.9,2.08-1.18s1.59-0.42,2.43-0.42h2.43L-471.12,267.36L-471.12,267.36z     M-457.9,267.36l-3.74-9.18c0.92-0.78,1.86-1.35,2.83-1.7c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64    s1.96,0.96,2.7,1.6l-3.74,9.18H-457.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -517.66,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -275.23,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -296.46,
    y: 248.29,
    className: "st0",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -373.87,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-486.28,260.34c0-0.94-0.12-1.81-0.38-2.63c-0.25-0.82-0.63-1.51-1.15-2.09c-0.64-0.7-1.35-1.22-2.14-1.57    s-1.75-0.52-2.89-0.52h-1.77v2.39h2.1c0.58,0,1.13,0.13,1.65,0.37c0.52,0.25,0.95,0.57,1.29,0.97c0.34,0.42,0.57,0.88,0.7,1.38    s0.2,1.1,0.2,1.79v6.94h-11.24v2.39h13.63L-486.28,260.34L-486.28,260.34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -169.66,
    y: 248.29,
    className: "st0",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -271.03,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-176.64,248.29h-2.4v19.07h-8.24c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45    c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.32,0.23-3.36,0.69    s-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77s-0.66,2.19-0.66,3.41c0,0.64,0.07,1.25,0.2,1.84c0.13,0.59,0.3,1.15,0.52,1.69h-7.43    c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84    c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.31,0.23-3.35,0.69c-1.04,0.46-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77    s-0.66,2.19-0.66,3.41c0,0.64,0.07,1.25,0.2,1.84c0.13,0.59,0.3,1.15,0.52,1.69h-7.61v-19.07h-2.4v19.07h-7.64v-3.66    c0-0.92-0.12-1.79-0.36-2.62s-0.62-1.53-1.14-2.11c-0.62-0.7-1.32-1.22-2.1-1.56s-1.77-0.51-2.97-0.51h-10.61l4.51-8.62h-2.61    l-4.6,8.59c0.08,0.52,0.2,0.97,0.38,1.35c0.17,0.38,0.4,0.74,0.7,1.08h12.22c0.76,0,1.41,0.11,1.96,0.35    c0.55,0.23,0.99,0.54,1.33,0.94s0.57,0.86,0.69,1.38c0.12,0.52,0.18,1.1,0.18,1.73v3.66h-22.17v-13.84h-3.78    c-1.5,0-2.86,0.2-4.07,0.61c-1.22,0.41-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23    c0,1.42,0.27,2.63,0.81,3.65s1.26,1.85,2.16,2.51s1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.77,0.48h47.55    c0.78,0.84,1.7,1.5,2.77,1.99s2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72s2.06-1.15,2.86-2h10.55    c0.78,0.84,1.7,1.5,2.77,1.99s2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72s2.06-1.15,2.86-2h12.19L-176.64,248.29    L-176.64,248.29z M-270.96,267.36h-2.37c-0.9,0-1.74-0.13-2.53-0.39s-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79    c-0.34-0.71-0.51-1.51-0.51-2.41c0-0.86,0.18-1.64,0.55-2.35s0.86-1.31,1.47-1.82c0.61-0.51,1.3-0.9,2.08-1.17    c0.78-0.27,1.58-0.4,2.4-0.4h2.37L-270.96,267.36L-270.96,267.36z M-212.67,266.3c-0.33,0.77-0.78,1.43-1.35,1.99    s-1.24,0.99-2.01,1.3c-0.77,0.31-1.6,0.46-2.5,0.46c-0.88,0-1.69-0.17-2.44-0.49c-0.75-0.33-1.4-0.78-1.95-1.35    s-0.98-1.23-1.29-1.99c-0.31-0.76-0.46-1.57-0.46-2.42c0-0.86,0.16-1.67,0.46-2.44c0.31-0.77,0.74-1.43,1.28-2    s1.18-1.02,1.93-1.36s1.57-0.51,2.47-0.51c0.92,0,1.76,0.16,2.53,0.48s1.44,0.76,2.01,1.32c0.57,0.56,1.01,1.22,1.33,1.99    s0.48,1.61,0.48,2.53C-212.17,264.7-212.34,265.53-212.67,266.3z M-189.42,266.3c-0.33,0.77-0.78,1.43-1.35,1.99    s-1.24,0.99-2.01,1.3c-0.77,0.31-1.6,0.46-2.5,0.46c-0.88,0-1.69-0.17-2.44-0.49c-0.75-0.33-1.4-0.78-1.95-1.35    s-0.98-1.23-1.29-1.99c-0.31-0.76-0.47-1.57-0.47-2.42c0-0.86,0.16-1.67,0.47-2.44s0.73-1.43,1.27-2    c0.54-0.57,1.18-1.02,1.93-1.36s1.57-0.51,2.47-0.51c0.92,0,1.76,0.16,2.53,0.48s1.44,0.76,2.01,1.32    c0.57,0.56,1.01,1.22,1.33,1.99s0.48,1.61,0.48,2.53C-188.92,264.7-189.09,265.53-189.42,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-522.74,269.27c1.2,0.32,2.46,0.48,3.77,0.48h15.7v-16.24h-2.4v13.84h-9.53v-13.84h-3.78    c-1.5,0-2.85,0.2-4.07,0.61c-1.22,0.41-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23    c0,1.42,0.27,2.63,0.81,3.65s1.26,1.85,2.16,2.51C-524.99,268.47-523.94,268.96-522.74,269.27z M-526.46,261.65    c0-0.86,0.19-1.64,0.56-2.35s0.86-1.31,1.47-1.82s1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37    c-0.9,0-1.74-0.13-2.53-0.39c-0.79-0.26-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79C-526.29,263.35-526.46,262.55-526.46,261.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -355.02,
    y: 272.59,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: -359.22,
    y: 272.59,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-334.5,272.79c0.15-0.75,0.23-1.59,0.23-2.53v-0.51h30.83v-21.46h-2.4v19.07h-10.19l4.19-10.02    c-0.64-0.56-1.32-1.08-2.04-1.57c-0.72-0.49-1.46-0.92-2.22-1.29s-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31    c-0.78,0-1.56,0.11-2.34,0.31c-0.78,0.21-1.55,0.49-2.32,0.85c-0.77,0.36-1.51,0.79-2.22,1.29s-1.37,1.02-1.99,1.58l4.22,10.02    h-8.93v-13.84h-2.4v16.75c0,0.68-0.03,1.25-0.1,1.72s-0.19,0.85-0.36,1.14c-0.17,0.29-0.4,0.5-0.69,0.63s-0.66,0.2-1.12,0.2    c-0.22,0-0.41-0.01-0.57-0.03s-0.38-0.07-0.66-0.15l-0.63,2.3c0.66,0.18,1.31,0.27,1.95,0.27c0.86,0,1.58-0.14,2.17-0.42    c0.59-0.28,1.06-0.68,1.42-1.21C-334.9,274.18-334.65,273.54-334.5,272.79z M-326.57,258.18c0.92-0.78,1.86-1.35,2.83-1.7    c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64s1.96,0.96,2.7,1.6l-3.74,9.18h-4.28L-326.57,258.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -521.86,
    y: 248.29,
    className: "st0",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-511.66,285.47 -515.35,285.47 -523.5,294.07 -523.5,285.47 -526.51,285.47 -526.51,302.56     -523.5,302.56 -523.5,297.61 -520.83,294.87 -514.99,302.56 -511.34,302.56 -518.78,292.82   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -508.6,
    y: 285.47,
    className: "st0",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-489,297.29 -498.17,285.47 -500.96,285.47 -500.96,302.56 -498,302.56 -498,290.4 -488.56,302.56     -486.04,302.56 -486.04,285.47 -489,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-473.58,295.63h4.38v3.2c-1.05,0.78-2.52,1.29-4.13,1.29c-3.5,0-5.82-2.59-5.82-6.1v-0.05    c0-3.27,2.39-6.03,5.55-6.03c2.18,0,3.47,0.71,4.79,1.83l1.91-2.27c-1.76-1.49-3.6-2.32-6.58-2.32c-5.16,0-8.83,4.05-8.83,8.84    v0.05c0,4.98,3.52,8.79,8.88,8.79c3.03,0,5.46-1.22,7.14-2.66v-7.18h-7.29L-473.58,295.63L-473.58,295.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-455.76,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05    C-446.66,289.16-450.38,285.47-455.76,285.47z M-449.81,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37    c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-434.86,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79c5.26,0,8.98-4.03,8.98-8.84    v-0.05C-425.94,289.16-429.61,285.18-434.86,285.18z M-429.09,294.07c0,3.32-2.37,6.03-5.77,6.03s-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03s5.82,2.76,5.82,6.08V294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-413.79,293.55 -419,285.47 -422.2,285.47 -422.2,302.56 -419.24,302.56 -419.24,290.36     -413.88,298.36 -413.79,298.36 -408.38,290.31 -408.38,302.56 -405.37,302.56 -405.37,285.47 -408.58,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-385.41,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79c5.26,0,8.98-4.03,8.98-8.84    v-0.05C-376.48,289.16-380.15,285.18-385.41,285.18z M-379.64,294.07c0,3.32-2.37,6.03-5.77,6.03s-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03s5.82,2.76,5.82,6.08V294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-372.74,302.56 -369.73,302.56 -369.73,295.6 -361.1,295.6 -361.1,292.87 -369.73,292.87     -369.73,288.21 -360,288.21 -360,285.47 -372.74,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-342.75,292.65c-3.28-0.78-4.06-1.37-4.06-2.68v-0.05c0-1.12,1.03-2.03,2.79-2.03    c1.57,0,3.11,0.61,4.65,1.76l1.61-2.27c-1.74-1.39-3.72-2.15-6.21-2.15c-3.4,0-5.85,2.03-5.85,4.95v0.05c0,3.15,2.06,4.22,5.7,5.1    c3.18,0.73,3.86,1.39,3.86,2.61V298c0,1.3-1.17,2.15-3.03,2.15c-2.13,0-3.77-0.81-5.41-2.22l-1.81,2.15    c2.06,1.83,4.52,2.73,7.14,2.73c3.6,0,6.11-1.9,6.11-5.1v-0.05C-337.25,294.82-339.13,293.53-342.75,292.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-328.03,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-328.03z M-329.62,295.78    l2.94-6.84l2.96,6.84H-329.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-304.3,295.31c0,3.15-1.64,4.76-4.31,4.76c-2.69,0-4.33-1.71-4.33-4.88v-9.72h-3.01v9.84    c0,4.95,2.84,7.52,7.29,7.52c4.48,0,7.36-2.56,7.36-7.66v-9.69h-3.01v9.83H-304.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-290.5,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05C-281.4,289.16-285.12,285.47-290.5,285.47z     M-284.56,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -277.59,
    y: 285.47,
    className: "st0",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-256.61,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-256.61z M-258.2,295.78    l2.94-6.84l2.96,6.84H-258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-229.45,290.92v-0.05c0-1.49-0.51-2.76-1.42-3.69c-1.1-1.07-2.79-1.71-4.94-1.71h-7.63v17.09h3.01v-5.96    h3.72h0.05l4.21,5.96h3.55l-4.62-6.47C-231.14,295.41-229.45,293.72-229.45,290.92z M-240.43,293.94v-5.74h4.38    c2.23,0,3.55,1,3.55,2.83v0.05c0,1.73-1.37,2.86-3.52,2.86L-240.43,293.94L-240.43,293.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-219.17,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H-219.17z M-220.76,295.78    l2.94-6.84l2.96,6.84H-220.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-195.15,293.68c1.27-0.66,2.45-1.76,2.45-3.81v-0.05c0-1.15-0.39-2.07-1.15-2.83    c-0.98-0.98-2.52-1.51-4.48-1.51h-7.68v17.09h7.92c3.82,0,6.33-1.63,6.33-4.69v-0.05C-191.75,295.51-193.14,294.36-195.15,293.68z     M-203.05,288.13h4.33c1.93,0,3.01,0.83,3.01,2.17v0.05c0,1.56-1.3,2.32-3.23,2.32h-4.11V288.13z M-194.76,297.56    c0,1.54-1.25,2.34-3.3,2.34h-4.99v-4.69h4.77c2.37,0,3.52,0.86,3.52,2.3V297.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -188.02,
    y: 285.47,
    className: "st0",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-171.82,285.35h-2.79l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18L-171.82,285.35z M-176.2,295.78    l2.94-6.84l2.96,6.84H-176.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.53,
    y: 58.23,
    className: "st2",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.62,
    y: 110.2,
    className: "st2",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M475.53,105.72c1.03-0.49,1.86-1.19,2.49-2.12c0.63-0.92,1.07-2.04,1.33-3.34c0.26-1.31,0.39-2.78,0.39-4.41    V66.59h-4.19v29.26c0,1.18-0.06,2.18-0.18,3s-0.33,1.48-0.63,1.99c-0.3,0.5-0.7,0.87-1.2,1.1c-0.51,0.23-1.16,0.34-1.96,0.34    c-0.38,0-0.72-0.02-0.99-0.05c-0.28-0.03-0.66-0.12-1.15-0.26l-1.1,4.02c1.15,0.32,2.29,0.47,3.4,0.47    C473.23,106.45,474.5,106.21,475.53,105.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461.13,59.18h-5.75v-0.97c0-0.53,0.11-0.94,0.34-1.23c0.19-0.24,0.64-0.36,1.29-0.36h2.88v-2.91h-2.95    c-1.6,0-2.85,0.42-3.69,1.25c-0.85,0.83-1.28,2.19-1.28,4.02v3.41h9.17v-3.21H461.13z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.24,
    y: 110.2,
    className: "st2",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.91,
    y: 58.23,
    className: "st2",
    width: 4.19,
    height: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M442.26,91.64c1.59,1.13,3.43,1.97,5.52,2.51s4.31,0.81,6.65,0.81h1.11l1.41-2.95v4.15    c0,2.19-0.63,3.76-1.88,4.7c-1.26,0.94-3.02,1.41-5.29,1.41c-1.29,0-2.45-0.12-3.48-0.37c-1.03-0.24-2.21-0.66-3.53-1.25    l-1.31,4.02c1.6,0.59,3.03,1.04,4.27,1.33c1.24,0.3,2.49,0.44,3.74,0.44c4.08,0,7.05-0.97,8.9-2.9c1.85-1.94,2.77-4.54,2.77-7.81    V66.59h-6.7c-2.58,0-4.94,0.37-7.07,1.1c-2.13,0.73-3.95,1.73-5.47,3s-2.7,2.79-3.53,4.55c-0.84,1.76-1.26,3.67-1.26,5.72    c0,2.47,0.46,4.59,1.39,6.35C439.41,89.06,440.67,90.51,442.26,91.64z M442.26,76.83c0.64-1.25,1.5-2.32,2.56-3.21    s2.28-1.57,3.64-2.06c1.32-0.47,2.69-0.71,4.11-0.72v-0.01h6.77l-2.39,1.19v18.77h-4.24c-1.57,0-3.04-0.22-4.42-0.66    c-1.38-0.43-2.59-1.07-3.64-1.91c-1.05-0.84-1.87-1.86-2.46-3.08s-0.89-2.61-0.89-4.18C441.29,79.46,441.61,78.08,442.26,76.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M338.67,105.87h8.7v-3.13c0.08,0.15,0.17,0.3,0.26,0.43c0.63,0.92,1.46,1.63,2.49,2.12    c1.03,0.49,2.29,0.73,3.79,0.73h76.35V66.59h-4.19v35.26h-4.35h-67.66c-0.8,0-1.46-0.11-1.96-0.34c-0.5-0.23-0.91-0.59-1.2-1.1    s-0.5-1.17-0.63-1.99c-0.12-0.82-0.18-1.82-0.18-3V66.59h-11.32c-11.58,0-19.46,9.17-19.46,19.64v0.11    C319.32,96.81,327.09,105.87,338.67,105.87z M323.78,86.12c0-8.63,6.2-15.57,14.89-15.57h9.8l-2.57,1.28v23.59    c0,1.64,0.13,3.11,0.39,4.41c0.15,0.76,0.37,1.45,0.65,2.08h-8.17c-8.7,0-15-7.05-15-15.68v-0.11H323.78z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.37,95.49 300.2,100.31 273.6,66.54 269.45,66.54 269.45,105.79 273.77,105.79 273.77,76.21     271.31,70.49 299.16,105.79 302.7,105.79 302.7,66.54 298.37,66.54   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.01,168.49l24.14-23.01V129.7h-64.52v17.97h33.08l12.27-7.88l-30.63,30.75l3.28,13.34h8.73    c11.73,0,18.69,4.36,18.69,12.12v0.27c0,7.08-5.59,11.57-13.5,11.57c-9.68,0-16.5-4.08-23.05-11.44l-14.46,13.75    c8.18,9.67,20.05,16.47,37.24,16.47c21.28,0,34.37-13.21,34.37-31.18v-0.27C383.66,177.48,370.97,170.67,358.01,168.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.19,65.87c-11.96,0-20.11,9.47-20.11,20.3v0.11c0,10.82,8.03,20.18,20,20.18s20.11-9.47,20.11-20.29    v-0.11C262.18,75.23,254.15,65.87,242.19,65.87z M257.58,86.28c0,8.91-6.4,16.09-15.39,16.09s-15.5-7.29-15.5-16.2v-0.11    c0-8.91,6.41-16.09,15.39-16.09c8.99,0,15.5,7.29,15.5,16.2V86.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.95,128.06c-29.46,0-50.88,22.19-50.88,49.28v0.27c0,27.09,21.14,49.01,50.6,49.01    s50.88-22.19,50.88-49.28v-0.27C490.56,149.98,469.41,128.06,439.95,128.06z M468.6,177.61c0,16.34-11.73,29.68-28.65,29.68    c-16.91,0-28.92-13.61-28.92-29.95v-0.27c0-16.34,11.73-29.68,28.64-29.68s28.92,13.61,28.92,29.95v0.27H468.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.98,
    y: 66.54,
    className: "st2",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.7,214.1l4.05-3.12l20.87-16.08c16.91-13.07,25.1-20.96,25.1-36.89v-0.27    c0-17.84-13.09-29.41-32.87-29.41c-17.05,0-26.19,6.94-35.6,19.74l14.73,11.84c7.09-8.71,12.14-12.79,19.51-12.79    c7.5,0,12.82,4.36,12.82,12.39c0,7.89-4.64,13.07-16.5,22.87l-31.78,26v16.61h70.66v-18.11h-36.41L138.7,214.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "138.99,106.07 155.89,66.54 151.12,66.54 137.76,98.71 138.18,103.03 137.08,100.35 125.51,72.39     123.09,66.54 118.15,66.54 135.06,106.07   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.92,
    y: 66.54,
    className: "st2",
    width: 4.44,
    height: 39.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.86,84.03c-8.65-1.85-10.67-3.92-10.67-7.62V76.3c0-3.53,3.26-6.33,8.37-6.33c4.04,0,7.7,1.29,11.35,4.26    l2.58-3.42c-3.99-3.2-8.09-4.82-13.82-4.82c-7.47,0-12.92,4.54-12.92,10.71v0.11c0,6.45,4.16,9.36,13.2,11.33    c8.26,1.74,10.22,3.81,10.22,7.46v0.11c0,3.87-3.48,6.67-8.76,6.67c-5.45,0-9.38-1.85-13.48-5.55l-2.75,3.25    c4.72,4.21,9.83,6.28,16.06,6.28c7.81,0,13.42-4.37,13.42-11.1v-0.11C202.66,89.14,198.62,85.94,189.86,84.03z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "246.74,121.79 251.58,126.42 246.94,131.25 242.1,126.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.81,126.62 262.64,131.25 267.28,126.42 262.45,121.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251,132.7 254.77,136.31 258.38,132.55 254.61,128.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "264.81,134.76 268.57,138.37 272.18,134.61 268.42,131.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "244.84,138.44 248.61,142.05 252.22,138.29 248.46,134.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "257.48,138.88 261.24,142.49 264.85,138.73 261.09,135.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "252.54,143.2 255.18,145.74 257.73,143.1 255.08,140.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "262.53,145.2 265.17,147.73 267.72,145.09 265.07,142.55  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.03,
    y: 124.27,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -18.4175 54.2487)",
    className: "st9",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.15,
    y: 127.86,
    transform: "matrix(0.9836 -0.1801 0.1801 0.9836 -19.093 52.1265)",
    className: "st10",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.91,
    y: 137.04,
    transform: "matrix(0.9836 -0.1804 0.1804 0.9836 -20.5624 54.6664)",
    className: "st7",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.69,
    y: 138.14,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -20.7744 52.8157)",
    className: "st5",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.68,
    y: 147.87,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -22.3641 54.775)",
    className: "st4",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 140.23,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -21.2769 51.4643)",
    className: "st7",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.32,
    y: 146.94,
    transform: "matrix(0.9836 -0.1802 0.1802 0.9836 -22.3334 53.2536)",
    className: "st6",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.65,
    y: 147.72,
    transform: "matrix(0.9836 -0.1803 0.1803 0.9836 -22.4648 51.9419)",
    className: "st4",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 155.17,
    transform: "matrix(0.9837 -0.1798 0.1798 0.9837 -23.6415 53.1601)",
    className: "st8",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "308.78,151.95 305.19,159.48 312.73,163.06 316.32,155.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "298.07,148.47 295.19,154.51 301.24,157.39 304.12,151.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "303.02,163.35 300.14,169.39 306.2,172.26 309.08,166.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "295.09,158.82 292.85,163.53 297.56,165.76 299.81,161.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "297.49,172.55 295.24,177.25 299.95,179.49 302.2,174.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "287.63,156.02 285.39,160.73 290.1,162.96 292.35,158.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.26,166.9 289.01,171.61 293.73,173.84 295.97,169.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "285.59,163.59 284.01,166.9 287.33,168.47 288.9,165.16  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.89,
    y: 174.28,
    transform: "matrix(0.4297 -0.903 0.903 0.4297 5.0644 360.2399)",
    className: "st7",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "312.84,188.01 305.52,192.01 309.54,199.32 316.86,195.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "306.2,178.93 300.32,182.15 303.55,188.01 309.42,184.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "301.49,193.89 295.62,197.11 298.84,202.97 304.72,199.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "297.72,185.58 293.14,188.09 295.65,192.65 300.23,190.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "291.61,198.11 287.04,200.62 289.55,205.18 294.12,202.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "293.31,178.96 288.74,181.46 291.24,186.03 295.82,183.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "289.87,189.9 285.29,192.4 287.8,196.97 292.38,194.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "287.22,183.9 284,185.66 285.77,188.87 288.98,187.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "282.32,192.82 279.1,194.58 280.87,197.79 284.09,196.03  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 219.04,
    transform: "matrix(0.1226 -0.9925 0.9925 0.1226 33.2173 483.9936)",
    className: "st6",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.86,
    y: 207.94,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 45.7008 474.2936)",
    className: "st10",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 217.33,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 25.3514 470.0449)",
    className: "st7",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.65,
    y: 208.5,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 37.227 464.3394)",
    className: "st6",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.35,
    y: 215.09,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 19.9012 457.9139)",
    className: "st4",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.96,
    y: 200.54,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 45.3265 457.5945)",
    className: "st4",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.76,
    y: 207.4,
    transform: "matrix(0.123 -0.9924 0.9924 0.123 30.4481 454.4734)",
    className: "st6",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.76,
    y: 201.1,
    transform: "matrix(0.1228 -0.9924 0.9924 0.1228 39.467 450.5196)",
    className: "st4",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.54,
    y: 205.47,
    transform: "matrix(0.1227 -0.9924 0.9924 0.1227 27.0772 445.2321)",
    className: "st4",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "262.01,234.83 255.89,229.16 250.2,235.27 256.32,240.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "260.88,118.05 254.76,112.38 249.07,118.49 255.2,124.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "268.54,225.68 263.63,221.13 259.07,226.03 263.98,230.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "252.84,225.94 247.92,221.39 243.36,226.29 248.28,230.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "259.54,219.75 255.72,216.2 252.17,220.02 255.99,223.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "245.7,217.91 241.88,214.37 238.33,218.18 242.16,221.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "264.45,213.48 260.63,209.94 257.08,213.75 260.9,217.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.96,213.67 249.14,210.13 245.59,213.94 249.41,217.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "257.83,209.27 255.14,206.77 252.64,209.46 255.33,211.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "247.81,207.44 245.12,204.95 242.62,207.63 245.31,210.12  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.24,
    y: 220.47,
    transform: "matrix(0.9805 -0.1965 0.1965 0.9805 -39.8252 47.8876)",
    className: "st9",
    width: 8.35,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 218.32,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -38.9973 50.0888)",
    className: "st7",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.83,
    y: 209.37,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -37.5377 47.4623)",
    className: "st6",
    width: 6.7,
    height: 6.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.48,
    y: 209.58,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -37.1916 49.3242)",
    className: "st5",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.14,
    y: 207.36,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -36.6081 50.7856)",
    className: "st3",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.72,
    y: 200.81,
    transform: "matrix(0.9805 -0.1964 0.1964 0.9805 -35.5055 48.8062)",
    className: "st9",
    width: 5.22,
    height: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.93,
    y: 201.49,
    transform: "matrix(0.9806 -0.1962 0.1962 0.9806 -35.3071 50.2077)",
    className: "st6",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.89,
    y: 194.14,
    transform: "matrix(0.9805 -0.1967 0.1967 0.9805 -34.0778 48.816)",
    className: "st4",
    width: 3.67,
    height: 3.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "201.45,201.45 204.92,193.86 197.31,190.41 193.85,197.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.22,204.75 214.99,198.67 208.9,195.89 206.12,201.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "207.02,189.96 209.8,183.87 203.7,181.1 200.92,187.19  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.11,
    y: 188.3,
    transform: "matrix(0.4149 -0.9099 0.9099 0.4149 -48.6661 306.1454)",
    className: "st7",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "221.38,206.21 223.54,201.47 218.79,199.31 216.63,204.05  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.52,
    y: 174.61,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -37.746 295.7368)",
    className: "st3",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.64,
    y: 190.98,
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -46.711 314.5165)",
    className: "st8",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.83,
    y: 180.18,
    transform: "matrix(0.4154 -0.9096 0.9096 0.4154 -39.1606 304.6351)",
    className: "st5",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "224.44,189.43 225.97,186.1 222.63,184.58 221.1,187.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "223.02,179.37 224.54,176.03 221.2,174.51 219.68,177.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "196.79,165.47 204.05,161.34 199.91,154.1 192.65,158.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "203.58,174.43 209.41,171.12 206.08,165.31 200.26,168.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "208.04,159.4 213.86,156.09 210.54,150.28 204.72,153.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "211.95,167.64 216.48,165.06 213.9,160.54 209.37,163.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.85,155.02 222.38,152.44 219.8,147.91 215.26,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "216.47,174.19 221,171.61 218.42,167.09 213.88,169.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "219.73,163.2 224.26,160.62 221.68,156.09 217.14,158.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "222.48,169.15 225.67,167.34 223.85,164.16 220.66,165.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "227.23,160.16 230.42,158.34 228.6,155.16 225.41,156.97  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.52,
    y: 125.7,
    transform: "matrix(0.1063 -0.9943 0.9943 0.1063 66.3044 333.5218)",
    className: "st6",
    width: 8.34,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.69,
    y: 138.49,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 53.8012 343.5408)",
    className: "st4",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.12,
    y: 128.9,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 74.4504 347.3374)",
    className: "st7",
    width: 6.69,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 139.27,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 62.6423 353.4799)",
    className: "st5",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.58,
    y: 132.45,
    transform: "matrix(0.1061 -0.9944 0.9944 0.1061 80.4046 359.5546)",
    className: "st9",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.22,
    y: 147.22,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 54.5804 360.4009)",
    className: "st7",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.3,
    y: 140.21,
    transform: "matrix(0.1065 -0.9943 0.9943 0.1065 69.6717 363.165)",
    className: "st6",
    width: 5.21,
    height: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.97,
    y: 148.11,
    transform: "matrix(0.1064 -0.9943 0.9943 0.1064 60.7215 367.4526)",
    className: "st10",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 143.57,
    transform: "matrix(0.1058 -0.9944 0.9944 0.1058 73.524 372.5816)",
    className: "st4",
    width: 3.66,
    height: 3.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M281.32,181.78c-0.62-0.35-1.75-0.94-3.31-1.43c-2.25-0.72-5.39-1.26-9.11-0.67   c-1.25,0.2-2.57,0.53-3.94,1.02c-0.13,0.05-0.26,0.09-0.39,0.14c-0.7,0.26-1.39,0.58-2.09,0.93c-0.6,0.3-1.19,0.63-1.78,0.99   c-1.35,0.81-2.68,1.73-3.97,2.73c-1.47-8.89-0.75-17.14-0.41-21.19c0-0.02,0.03-0.03,0.05-0.02c3.15,1.98,2.27,7.51,1.6,9.1   c-0.01,0.03,0.03,0.05,0.06,0.03c3.92-4.63,2.01-9.75,1.2-11.04c-0.02-0.03,0.02-0.06,0.05-0.04c0.57,0.46,1.03,0.95,1.42,1.45   c1.21,1.55,1.66,3.22,1.78,4.7c0.06,0.78,0.04,1.5,0,2.12c-0.01,0.17-0.02,0.32-0.04,0.47c0,0.02,0.02,0.03,0.04,0.02   c0.01,0,0.02,0,0.02-0.01c1.06-2.08,1.57-5.22-0.02-8.27c-0.43-0.83-1.01-1.65-1.78-2.44c-0.22-0.23-0.46-0.45-0.71-0.68   c-0.02-0.02,0-0.06,0.03-0.05c0.24,0.06,0.46,0.13,0.68,0.2c0.67,0.23,1.26,0.55,1.78,0.94c1.19,0.88,2,2.08,2.48,3.34   c0.4,1.04,0.58,2.11,0.58,3.06c0,0.04,0.05,0.04,0.06,0.01c0.74-2.71,0.29-4.76-0.64-6.25c-0.66-1.07-1.57-1.85-2.48-2.4   c-0.62-0.37-1.24-0.63-1.78-0.79c-0.32-0.1-0.6-0.16-0.85-0.19c-0.04,0-0.03-0.06,0.01-0.06c0.29-0.03,0.57-0.04,0.84-0.05   c0.66-0.01,1.25,0.05,1.78,0.14c1.05,0.2,1.87,0.56,2.48,0.98c1,0.67,1.5,1.46,1.67,1.78c0.01,0.03,0.06,0.01,0.06-0.02   c-0.14-1.43-0.8-2.55-1.72-3.35c-0.71-0.62-1.58-1.05-2.48-1.31c-0.59-0.16-1.19-0.25-1.78-0.26c-0.8-0.01-1.57,0.12-2.22,0.4   c-0.03,0.01-0.05-0.02-0.04-0.05c0.58-0.83,1.4-1.33,2.26-1.6c0.6-0.18,1.21-0.25,1.78-0.21c0.55,0.03,1.05,0.15,1.46,0.34   c0.03,0.01,0.05-0.02,0.03-0.05c-0.45-0.51-0.96-0.91-1.49-1.21c-0.57-0.32-1.17-0.51-1.78-0.58c-1.59-0.18-3.21,0.5-4.29,2.13   c-0.01,0.02-0.04,0.02-0.05,0c-0.21-0.37-0.41-0.78-0.59-1.21c-0.43-1-0.78-2.12-0.97-3.24c-0.01-0.04-0.05-0.04-0.05,0   c-0.19,1.12-0.55,2.25-0.98,3.25c-0.19,0.43-0.38,0.83-0.59,1.19c-0.01,0.02-0.04,0.02-0.05,0c-1.88-2.85-5.41-2.79-7.56-0.33   c-0.02,0.02,0,0.06,0.03,0.05c1.43-0.68,4.14-0.48,5.5,1.47c0.02,0.03-0.01,0.06-0.04,0.05c-2.09-0.88-5.33-0.31-7.06,1.75   c-0.62,0.73-1.04,1.66-1.15,2.77c0,0.03,0.04,0.05,0.06,0.02c0.13-0.25,0.47-0.79,1.09-1.34c1.01-0.89,2.77-1.79,5.68-1.52   c0.04,0.01,0.04,0.06,0.01,0.06c-1.49,0.18-4.56,1.51-5.69,4.55c-0.5,1.34-0.63,3.02-0.07,5.08c0.01,0.03,0.06,0.03,0.06-0.01   c0-0.05,0-0.09,0.01-0.14c0.03-2.76,1.61-6.46,5.52-7.4c0.03-0.01,0.05,0.03,0.03,0.05c-4.37,3.84-3.94,8.58-2.51,11.38   c0.02,0.03,0.06,0.02,0.06-0.01c-0.19-2.12-0.34-5.89,3.16-8.74c0.03-0.02,0.07,0.01,0.05,0.04c-0.81,1.3-2.72,6.41,1.2,11.04   c0.02,0.03,0.07,0.01,0.06-0.03c-0.66-1.58-1.54-7.12,1.6-9.1c0.02-0.01,0.05,0,0.05,0.02c0.34,4.05,1.06,12.3-0.41,21.19   c-2.53-1.94-5.2-3.64-7.84-4.64c-0.33-0.12-0.65-0.23-0.96-0.34c-2.73-0.9-5.23-1.15-7.41-1.05c-3.5,0.15-6.18,1.2-7.65,1.93   c-0.3,0.15-0.55,0.29-0.74,0.4c-0.08,0.05-0.02,0.16,0.06,0.13c0.23-0.07,0.45-0.14,0.68-0.2c2.69-0.76,5.24-0.96,7.65-0.75   c2.63,0.23,5.1,0.95,7.41,1.99c3.24,1.46,6.17,3.54,8.82,5.74c-3.74,3.26-6.9,6.43-8.82,7.54c-0.1,0.05-0.19,0.11-0.28,0.16   c-0.46-0.63-1.26-0.99-2.13-0.8c-0.76,0.17-1.38,0.78-1.55,1.53c-0.15,0.67,0.02,1.4,0.4,1.78c1.02,1.02,2.2,1.09,3.56,0.52   c2.59-1.09,5.81-4.51,9.76-8.13c0.33-0.3,0.66-0.61,1-0.91c0.34,0.3,0.67,0.6,1,0.9c1.79,1.64,3.43,3.24,4.93,4.6   c0.62,0.56,1.21,1.08,1.78,1.54c0.88,0.72,1.71,1.31,2.48,1.72c1.51,0.8,2.82,0.9,3.94-0.09c0.06-0.05,0.12-0.1,0.18-0.16   c0.26-0.26,0.56-1.11,0.4-1.78c-0.09-0.39-0.3-0.74-0.59-1.01c-0.26-0.25-0.6-0.44-0.96-0.52c-0.87-0.19-1.67,0.17-2.13,0.8   c-0.26-0.13-0.54-0.31-0.85-0.52c-0.71-0.49-1.54-1.18-2.48-2c-0.56-0.49-1.15-1.03-1.78-1.6c-1.22-1.11-2.56-2.33-3.98-3.58   c1.26-1.05,2.59-2.07,3.98-3.01c0.58-0.39,1.17-0.77,1.78-1.13c0.81-0.48,1.63-0.92,2.48-1.33c1.27-0.61,2.58-1.12,3.94-1.51   c2.82-0.81,5.85-1.08,9.11-0.56c1.06,0.17,2.14,0.42,3.25,0.76C281.34,181.94,281.4,181.83,281.32,181.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.54,
    y: 272.59,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.17,269.75v-16.24h-2.4v13.84h-9.05v-13.84h-2.4v13.84h-9.53v-13.84h-3.77c-1.5,0-2.86,0.2-4.08,0.61    s-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65s1.26,1.85,2.16,2.51    s1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.78,0.48L303.17,269.75L303.17,269.75z M272.5,266.97c-0.79-0.26-1.48-0.63-2.07-1.12    s-1.05-1.09-1.39-1.79c-0.34-0.71-0.51-1.51-0.51-2.41c0-0.86,0.19-1.64,0.56-2.35s0.86-1.31,1.47-1.82    c0.61-0.51,1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37C274.14,267.36,273.29,267.23,272.5,266.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 248.29,
    className: "st2",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.33,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.74,
    y: 272.56,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.74,
    y: 272.59,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.52,267.36h-3.92c-1.4,0-2.5-0.2-3.3-0.6s-1.43-1-1.89-1.79c0.14-0.62,0.21-1.37,0.21-2.24v-7.72h-2.4    v8.1c0,1.38-0.37,2.48-1.11,3.31s-1.86,1.24-3.36,1.24c-0.7,0-1.34-0.11-1.92-0.33s-1.08-0.52-1.5-0.9s-0.75-0.82-0.99-1.33    c-0.24-0.51-0.37-1.05-0.39-1.63v-8.46h-2.4v8.28c0,0.74-0.11,1.36-0.33,1.87s-0.52,0.93-0.9,1.26c-0.38,0.33-0.81,0.57-1.29,0.72    s-0.99,0.22-1.53,0.22h-4.64v-12.35h-2.4v12.35H195.9l4.19-10.02c-0.64-0.56-1.32-1.08-2.04-1.57c-0.72-0.49-1.46-0.92-2.22-1.29    s-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31c-0.78,0-1.56,0.11-2.34,0.31c-0.78,0.21-1.55,0.49-2.32,0.85    s-1.51,0.79-2.22,1.29s-1.37,1.02-1.99,1.58l4.22,10.02h-8.3v-13.84h-3.83c-1.48,0-2.83,0.21-4.05,0.63s-2.26,0.99-3.13,1.72    c-0.87,0.73-1.54,1.6-2.02,2.6c-0.48,1.01-0.72,2.1-0.72,3.28c0,1.42,0.26,2.63,0.79,3.63c0.53,1.01,1.25,1.84,2.16,2.48    c0.91,0.65,1.96,1.13,3.16,1.43c1.2,0.31,2.47,0.46,3.81,0.46h1.44v0.69c0,1.26-0.36,2.15-1.08,2.69s-1.73,0.81-3.03,0.81    c-0.74,0-1.4-0.07-1.99-0.21c-0.59-0.14-1.26-0.38-2.02-0.72l-0.75,2.3c0.92,0.34,1.73,0.59,2.44,0.76s1.42,0.26,2.14,0.26    c2.34,0,4.03-0.55,5.09-1.66c1.06-1.11,1.59-2.6,1.59-4.47v-0.45h37.24c1.16,0,2.19-0.25,3.1-0.75s1.64-1.17,2.2-2    c0.58,0.96,1.37,1.71,2.37,2.24c1,0.54,2.19,0.81,3.57,0.81c1.44,0,2.66-0.25,3.67-0.75s1.78-1.26,2.32-2.3    c0.2,0.34,0.44,0.67,0.73,1s0.66,0.62,1.12,0.88c0.46,0.26,1.02,0.47,1.66,0.63c0.49,0.12,1.08,0.18,1.72,0.21v0.03h6.92v-21.46    h-2.4v19.08H242.52z M175.88,267.36h-2.43c-0.9,0-1.74-0.12-2.53-0.37s-1.48-0.61-2.08-1.09s-1.07-1.07-1.41-1.76    c-0.34-0.7-0.51-1.5-0.51-2.39c0-0.86,0.18-1.64,0.55-2.36c0.37-0.72,0.86-1.33,1.47-1.84s1.3-0.9,2.08-1.18s1.59-0.42,2.43-0.42    h2.43V267.36z M189.1,267.36l-3.74-9.18c0.92-0.78,1.86-1.35,2.83-1.7c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64    c1.06,0.43,1.96,0.96,2.7,1.6l-3.74,9.18H189.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.34,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.77,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.54,
    y: 248.29,
    className: "st2",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.13,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.72,260.34c0-0.94-0.12-1.81-0.38-2.63c-0.25-0.82-0.63-1.51-1.15-2.09c-0.64-0.7-1.35-1.22-2.14-1.57    s-1.75-0.52-2.89-0.52h-1.77v2.39h2.1c0.58,0,1.13,0.13,1.65,0.37c0.52,0.25,0.95,0.57,1.29,0.97c0.34,0.42,0.57,0.88,0.7,1.38    c0.13,0.5,0.2,1.1,0.2,1.79v6.94h-11.24v2.39h13.63L160.72,260.34L160.72,260.34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.34,
    y: 248.29,
    className: "st2",
    width: 2.4,
    height: 21.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.97,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.36,248.29h-2.4v19.07h-8.24c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45    c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.32,0.23-3.36,0.69    c-1.04,0.46-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77s-0.66,2.19-0.66,3.41c0,0.64,0.07,1.25,0.2,1.84s0.3,1.15,0.52,1.69h-7.43    c0.5-1.1,0.75-2.27,0.75-3.53c0-1.23-0.23-2.39-0.67-3.45c-0.45-1.07-1.06-1.99-1.84-2.76c-0.78-0.78-1.7-1.39-2.77-1.84    c-1.07-0.45-2.22-0.67-3.46-0.67c-1.2,0-2.31,0.23-3.35,0.69s-1.94,1.08-2.71,1.87s-1.37,1.71-1.81,2.77s-0.66,2.19-0.66,3.41    c0,0.64,0.07,1.25,0.2,1.84s0.3,1.15,0.52,1.69h-7.61v-19.07h-2.4v19.07h-7.64v-3.66c0-0.92-0.12-1.79-0.36-2.62    s-0.62-1.53-1.14-2.11c-0.62-0.7-1.32-1.22-2.1-1.56s-1.77-0.51-2.97-0.51h-10.61l4.51-8.62h-2.61l-4.6,8.59    c0.08,0.52,0.2,0.97,0.38,1.35c0.17,0.38,0.4,0.74,0.7,1.08h12.22c0.76,0,1.41,0.11,1.96,0.35c0.55,0.23,0.99,0.54,1.33,0.94    s0.57,0.86,0.69,1.38c0.12,0.52,0.18,1.1,0.18,1.73v3.66h-22.17v-13.84h-3.78c-1.5,0-2.86,0.2-4.07,0.61    c-1.22,0.41-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65    s1.26,1.85,2.16,2.51s1.95,1.15,3.15,1.46c1.2,0.32,2.46,0.48,3.77,0.48h47.55c0.78,0.84,1.7,1.5,2.77,1.99    c1.07,0.49,2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72s2.06-1.15,2.86-2h10.55c0.78,0.84,1.7,1.5,2.77,1.99    c1.07,0.49,2.23,0.73,3.49,0.73c1.28,0,2.47-0.24,3.58-0.72s2.06-1.15,2.86-2h12.19L470.36,248.29L470.36,248.29z M376.04,267.36    h-2.37c-0.9,0-1.74-0.13-2.53-0.39s-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79c-0.34-0.71-0.51-1.51-0.51-2.41    c0-0.86,0.18-1.64,0.55-2.35s0.86-1.31,1.47-1.82c0.61-0.51,1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37L376.04,267.36    L376.04,267.36z M434.33,266.3c-0.33,0.77-0.78,1.43-1.35,1.99s-1.24,0.99-2.01,1.3c-0.77,0.31-1.6,0.46-2.5,0.46    c-0.88,0-1.69-0.17-2.44-0.49c-0.75-0.33-1.4-0.78-1.95-1.35c-0.55-0.57-0.98-1.23-1.29-1.99c-0.31-0.76-0.46-1.57-0.46-2.42    c0-0.86,0.16-1.67,0.46-2.44c0.31-0.77,0.74-1.43,1.28-2s1.18-1.02,1.93-1.36s1.57-0.51,2.47-0.51c0.92,0,1.76,0.16,2.53,0.48    s1.44,0.76,2.01,1.32s1.01,1.22,1.33,1.99c0.32,0.77,0.48,1.61,0.48,2.53C434.83,264.7,434.66,265.53,434.33,266.3z M457.58,266.3    c-0.33,0.77-0.78,1.43-1.35,1.99s-1.24,0.99-2.01,1.3c-0.77,0.31-1.6,0.46-2.5,0.46c-0.88,0-1.69-0.17-2.44-0.49    c-0.75-0.33-1.4-0.78-1.95-1.35c-0.55-0.57-0.98-1.23-1.29-1.99c-0.31-0.76-0.47-1.57-0.47-2.42c0-0.86,0.16-1.67,0.47-2.44    s0.73-1.43,1.27-2c0.54-0.57,1.18-1.02,1.93-1.36s1.57-0.51,2.47-0.51c0.92,0,1.76,0.16,2.53,0.48s1.44,0.76,2.01,1.32    s1.01,1.22,1.33,1.99c0.32,0.77,0.48,1.61,0.48,2.53C458.08,264.7,457.91,265.53,457.58,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.26,269.27c1.2,0.32,2.46,0.48,3.77,0.48h15.7v-16.24h-2.4v13.84h-9.53v-13.84h-3.78    c-1.5,0-2.85,0.2-4.07,0.61s-2.26,0.98-3.12,1.7c-0.86,0.73-1.52,1.59-1.99,2.59s-0.7,2.07-0.7,3.23c0,1.42,0.27,2.63,0.81,3.65    s1.26,1.85,2.16,2.51C122.01,268.47,123.06,268.96,124.26,269.27z M120.54,261.65c0-0.86,0.19-1.64,0.56-2.35    c0.37-0.71,0.86-1.31,1.47-1.82s1.3-0.9,2.08-1.17c0.78-0.27,1.58-0.4,2.4-0.4h2.37v11.45h-2.37c-0.9,0-1.74-0.13-2.53-0.39    s-1.48-0.63-2.07-1.12s-1.05-1.09-1.39-1.79C120.71,263.35,120.54,262.55,120.54,261.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 272.59,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.78,
    y: 272.59,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.5,272.79c0.15-0.75,0.23-1.59,0.23-2.53v-0.51h30.83v-21.46h-2.4v19.07h-10.19l4.19-10.02    c-0.64-0.56-1.32-1.08-2.04-1.57c-0.72-0.49-1.46-0.92-2.22-1.29s-1.53-0.66-2.31-0.87c-0.78-0.21-1.55-0.31-2.31-0.31    c-0.78,0-1.56,0.11-2.34,0.31c-0.78,0.21-1.55,0.49-2.32,0.85c-0.77,0.36-1.51,0.79-2.22,1.29s-1.37,1.02-1.99,1.58l4.22,10.02    h-8.93v-13.84h-2.4v16.75c0,0.68-0.03,1.25-0.1,1.72s-0.19,0.85-0.36,1.14c-0.17,0.29-0.4,0.5-0.69,0.63s-0.66,0.2-1.12,0.2    c-0.22,0-0.41-0.01-0.57-0.03s-0.38-0.07-0.66-0.15l-0.63,2.3c0.66,0.18,1.31,0.27,1.95,0.27c0.86,0,1.58-0.14,2.17-0.42    c0.59-0.28,1.06-0.68,1.42-1.21C312.1,274.18,312.35,273.54,312.5,272.79z M320.43,258.18c0.92-0.78,1.86-1.35,2.83-1.7    c0.97-0.36,1.98-0.54,3.04-0.54c1.08,0,2.15,0.21,3.21,0.64s1.96,0.96,2.7,1.6l-3.74,9.18h-4.28L320.43,258.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.14,
    y: 248.29,
    className: "st2",
    width: 2.46,
    height: 2.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "135.34,285.47 131.65,285.47 123.5,294.07 123.5,285.47 120.49,285.47 120.49,302.56 123.5,302.56     123.5,297.61 126.17,294.87 132.01,302.56 135.66,302.56 128.22,292.82   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.4,
    y: 285.47,
    className: "st2",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "158,297.29 148.83,285.47 146.04,285.47 146.04,302.56 149,302.56 149,290.4 158.44,302.56     160.96,302.56 160.96,285.47 158,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.42,295.63h4.38v3.2c-1.05,0.78-2.52,1.29-4.13,1.29c-3.5,0-5.82-2.59-5.82-6.1v-0.05    c0-3.27,2.39-6.03,5.55-6.03c2.18,0,3.47,0.71,4.79,1.83l1.91-2.27c-1.76-1.49-3.6-2.32-6.58-2.32c-5.16,0-8.83,4.05-8.83,8.84    v0.05c0,4.98,3.52,8.79,8.88,8.79c3.03,0,5.46-1.22,7.14-2.66v-7.18h-7.29V295.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.24,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05C200.34,289.16,196.62,285.47,191.24,285.47z     M197.19,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.14,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79c5.26,0,8.98-4.03,8.98-8.84    v-0.05C221.06,289.16,217.39,285.18,212.14,285.18z M217.91,294.07c0,3.32-2.37,6.03-5.77,6.03c-3.4,0-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03c3.4,0,5.82,2.76,5.82,6.08V294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "233.21,293.55 228,285.47 224.8,285.47 224.8,302.56 227.76,302.56 227.76,290.36 233.12,298.36     233.21,298.36 238.62,290.31 238.62,302.56 241.63,302.56 241.63,285.47 238.42,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.59,285.18c-5.26,0-8.97,4.03-8.97,8.84v0.05c0,4.81,3.67,8.79,8.93,8.79c5.26,0,8.98-4.03,8.98-8.84    v-0.05C270.52,289.16,266.85,285.18,261.59,285.18z M267.36,294.07c0,3.32-2.37,6.03-5.77,6.03s-5.82-2.76-5.82-6.08v-0.05    c0-3.32,2.37-6.03,5.77-6.03s5.82,2.76,5.82,6.08V294.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "274.26,302.56 277.27,302.56 277.27,295.6 285.9,295.6 285.9,292.87 277.27,292.87 277.27,288.21     287,288.21 287,285.47 274.26,285.47   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.25,292.65c-3.28-0.78-4.06-1.37-4.06-2.68v-0.05c0-1.12,1.03-2.03,2.79-2.03c1.57,0,3.11,0.61,4.65,1.76    l1.61-2.27c-1.74-1.39-3.72-2.15-6.21-2.15c-3.4,0-5.85,2.03-5.85,4.95v0.05c0,3.15,2.06,4.22,5.7,5.1    c3.18,0.73,3.86,1.39,3.86,2.61V298c0,1.3-1.17,2.15-3.03,2.15c-2.13,0-3.77-0.81-5.41-2.22l-1.81,2.15    c2.06,1.83,4.52,2.73,7.14,2.73c3.6,0,6.11-1.9,6.11-5.1v-0.05C309.75,294.82,307.87,293.53,304.25,292.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.97,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H318.97z M317.38,295.78l2.94-6.84    l2.96,6.84H317.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.7,295.31c0,3.15-1.64,4.76-4.31,4.76c-2.69,0-4.33-1.71-4.33-4.88v-9.72h-3.01v9.84    c0,4.95,2.84,7.52,7.29,7.52c4.48,0,7.36-2.56,7.36-7.66v-9.69h-3.01v9.83H342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.5,285.47h-6.38v17.09h6.38c5.38,0,9.1-3.73,9.1-8.55v-0.05C365.6,289.16,361.88,285.47,356.5,285.47z     M362.44,294.07c0,3.34-2.35,5.76-5.94,5.76h-3.37v-11.62h3.37c3.6,0,5.94,2.47,5.94,5.81V294.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.41,
    y: 285.47,
    className: "st2",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.39,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H390.39z M388.8,295.78l2.94-6.84    l2.96,6.84H388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M417.55,290.92v-0.05c0-1.49-0.51-2.76-1.42-3.69c-1.1-1.07-2.79-1.71-4.94-1.71h-7.63v17.09h3.01v-5.96h3.72    h0.05l4.21,5.96h3.55l-4.62-6.47C415.86,295.41,417.55,293.72,417.55,290.92z M406.57,293.94v-5.74h4.38c2.23,0,3.55,1,3.55,2.83    v0.05c0,1.73-1.37,2.86-3.52,2.86L406.57,293.94L406.57,293.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M427.83,285.35l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18l-7.53-17.21H427.83z M426.24,295.78l2.94-6.84    l2.96,6.84H426.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.85,293.68c1.27-0.66,2.45-1.76,2.45-3.81v-0.05c0-1.15-0.39-2.07-1.15-2.83    c-0.98-0.98-2.52-1.51-4.48-1.51h-7.68v17.09h7.92c3.82,0,6.33-1.63,6.33-4.69v-0.05C455.25,295.51,453.86,294.36,451.85,293.68z     M443.95,288.13h4.33c1.93,0,3.01,0.83,3.01,2.17v0.05c0,1.56-1.3,2.32-3.23,2.32h-4.11V288.13z M452.24,297.56    c0,1.54-1.25,2.34-3.3,2.34h-4.99v-4.69h4.77c2.37,0,3.52,0.86,3.52,2.3V297.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.98,
    y: 285.47,
    className: "st2",
    width: 3.01,
    height: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M475.18,285.35h-2.79l-7.53,17.21h3.08l1.76-4.13h8.1l1.74,4.13h3.18L475.18,285.35z M470.8,295.78l2.94-6.84    l2.96,6.84H470.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision2030);
export default __webpack_public_path__ + "static/media/vision2030.05dcaa73122f6e5c1fe4d83f8f5a1b39.svg";
export { ForwardRef as ReactComponent };